// // New Code
// import React, { useState, useEffect, useCallback, useMemo, useRef } from "react";
// import { Container, Form, Spinner, Button } from "react-bootstrap";
// import {
//     BarChart,
//     Bar,
//     XAxis,
//     YAxis,
//     CartesianGrid,
//     Tooltip,
//     ResponsiveContainer,
//     Legend,
// } from "recharts";
// import PropTypes from "prop-types";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import OutletDetailsModal from "./OutletDetailsModal";
// import { useNavigate } from "react-router-dom";
// import axiosInstance from "../api/axios";

// const FILTER_OPTIONS = [
//     { label: "Total Sales", value: "totalSales", dataKey: "totalRevenue" },
//     { label: "Net Sales", value: "netSales", dataKey: "netSaleRevenue" },
//     { label: "Orders", value: "orders", dataKey: "totalOrders" },
// ];

// const SORT_OPTIONS = [
//     { label: "Top 10 Outlets", value: "-1" },
//     { label: "Bottom 10 Outlets", value: "1" },
// ];

// const DATE_FILTER_OPTIONS = [
//     { label: "Today", value: "today" },
//     { label: "Yesterday", value: "yesterday" },
//     { label: "Last 7 Days", value: "last7days" },
//     { label: "Last 30 Days", value: "last30days" },
//     { label: "This Month", value: "thisMonth" },
//     { label: "Last Month", value: "lastMonth" },
//     { label: "Custom Range", value: "custom" },
// ];

// // Height of the scrollable outlet-list body. Responsive: never taller than
// // 55% of the viewport, capped at 560px so it still behaves on huge monitors.
// const TABLE_BODY_MAX_HEIGHT = "min(55vh, 560px)";

// // How far the horizontal arrow controls scroll the table per click.
// const ARROW_SCROLL_DELTA = 360;

// // Columns that are always shown, in order. This drives calculations
// // (calculatedTotals sums every one of these) — it is NOT the same as what
// // gets rendered; see `displayColumns` below for the merged Quick
// // Order/Quick Serve presentation.
// const BASE_TABLE_COLUMNS = [
//     { key: "outletName", label: "Outlet Name", sortable: true, isNumeric: false, type: "text" },
//     { key: "totalOrders", label: "Total Orders", sortable: true, isNumeric: true, type: "count" },
//     { key: "cancelledOrders", label: "Canc. Orders", sortable: true, isNumeric: true, type: "count" },
//     // NEW: Complimentary Orders — note this count is NOT included inside
//     // `totalOrders` (see the Total Sales summary card, which calls this
//     // out explicitly next to the Orders figure).
//     { key: "complimentaryOrders", label: "Compl. Orders", sortable: true, isNumeric: true, type: "count" },
//     { key: "totalRevenue", label: "Total Sales", sortable: true, isNumeric: true, type: "amount" },
//     // NEW: Gross Sales = Total Sales + Zomato (totalSales) + Swiggy (totalSales)
//     { key: "grossSales", label: "Gross Sales", sortable: true, isNumeric: true, type: "amount" },
//     { key: "netSaleRevenue", label: "Net Sales", sortable: true, isNumeric: true, type: "amount" },
//     {
//         key: "netSalesInclThirdParty",
//         label: "Net Sales (incl. Zom/Swig)",
//         sortable: true,
//         isNumeric: true,
//         type: "amount",
//     },
//     // NEW: Offline Sales = Quick Order Revenue + Quick Serve Revenue
//     { key: "offlineSales", label: "Offline Sales", sortable: true, isNumeric: true, type: "amount" },
//     { key: "totalCancelledOrderAmount", label: "Canc. Amount", sortable: true, isNumeric: true, type: "amount" },
//     { key: "appOrders", label: "App Orders", sortable: true, isNumeric: true, type: "count" },
//     { key: "appNetSaleRevenue", label: "App Net Revenue", sortable: true, isNumeric: true, type: "amount" },
//     { key: "kioskOrders", label: "Kiosk Orders", sortable: true, isNumeric: true, type: "count" },
//     { key: "kioskNetSale", label: "Kiosk Net Sale", sortable: true, isNumeric: true, type: "amount" },
//     { key: "totalQuickOrderNetSaleCount", label: "Quick Order Count", sortable: true, isNumeric: true, type: "count" },
//     { key: "totalQuickOrderNetSaleRevenue", label: "Quick Order Revenue", sortable: true, isNumeric: true, type: "amount" },
//     { key: "totalQuickServeNetSaleCount", label: "Quick Serve Count", sortable: true, isNumeric: true, type: "count" },
//     { key: "totalQuickServeNetSaleRevenue", label: "Quick Serve Revenue", sortable: true, isNumeric: true, type: "amount" },
// ];

// // Columns that only appear when the current response actually contains that
// // platform's data (i.e. at least one outlet took a Zomato/Swiggy order).
// const OPTIONAL_TABLE_COLUMNS = [
//     {
//         key: "zomatoOrders",
//         label: "Zomato Orders",
//         sortable: true,
//         isNumeric: true,
//         type: "count",
//         presenceKeys: ["zomatoOrders", "zomatoNetSaleRevenue", "zomatoRevenue"],
//     },
//     {
//         key: "zomatoNetSaleRevenue",
//         label: "Zomato Revenue",
//         sortable: true,
//         isNumeric: true,
//         type: "amount",
//         fallbackKey: "zomatoRevenue",
//         presenceKeys: ["zomatoOrders", "zomatoNetSaleRevenue", "zomatoRevenue"],
//         platformName: "ZOMATO",
//     },
//     {
//         key: "swiggyOrders",
//         label: "Swiggy Orders",
//         sortable: true,
//         isNumeric: true,
//         type: "count",
//         presenceKeys: ["swiggyOrders", "swiggyNetSaleRevenue", "swiggyRevenue"],
//     },
//     {
//         key: "swiggyNetSaleRevenue",
//         label: "Swiggy Revenue",
//         sortable: true,
//         isNumeric: true,
//         type: "amount",
//         fallbackKey: "swiggyRevenue",
//         presenceKeys: ["swiggyOrders", "swiggyNetSaleRevenue", "swiggyRevenue"],
//         platformName: "SWIGGY",
//     },
// ];

// // Pairs of (count, revenue) columns that should render as ONE combined
// // column: revenue on top (the number that matters most), order count
// // underneath it as context. Purely a display concern — the underlying
// // `totalQuickOrderNetSaleCount` / `totalQuickOrderNetSaleRevenue` fields
// // (and their totals) are still computed exactly as before.
// const COMBO_COLUMN_DEFS = [
//     {
//         key: "cancelledCombo",
//         label: "Cancelled",
//         type: "combo",
//         sortable: true,
//         countKey: "cancelledOrders",
//         amountKey: "totalCancelledOrderAmount",
//         replaces: ["cancelledOrders", "totalCancelledOrderAmount"],
//         insertAfterKey: "totalCancelledOrderAmount",
//     },
//     {
//         key: "appCombo",
//         label: "App",
//         type: "combo",
//         sortable: true,
//         countKey: "appOrders",
//         amountKey: "appNetSaleRevenue",
//         replaces: ["appOrders", "appNetSaleRevenue"],
//         insertAfterKey: "appNetSaleRevenue",
//     },
//     {
//         key: "kioskCombo",
//         label: "Kiosk",
//         type: "combo",
//         sortable: true,
//         countKey: "kioskOrders",
//         amountKey: "kioskNetSale",
//         replaces: ["kioskOrders", "kioskNetSale"],
//         insertAfterKey: "kioskNetSale",
//     },
//     {
//         key: "quickOrderCombo",
//         label: "Qr Web Orders",
//         type: "combo",
//         sortable: true,
//         countKey: "totalQuickOrderNetSaleCount",
//         amountKey: "totalQuickOrderNetSaleRevenue",
//         replaces: ["totalQuickOrderNetSaleCount", "totalQuickOrderNetSaleRevenue"],
//         insertAfterKey: "totalQuickOrderNetSaleRevenue",
//     },
//     {
//         key: "quickServeCombo",
//         label: "Walk In",
//         type: "combo",
//         sortable: true,
//         countKey: "totalQuickServeNetSaleCount",
//         amountKey: "totalQuickServeNetSaleRevenue",
//         replaces: ["totalQuickServeNetSaleCount", "totalQuickServeNetSaleRevenue"],
//         insertAfterKey: "totalQuickServeNetSaleRevenue",
//     },
// ];

// // When a combo column header is clicked, sort by its revenue field — that's
// // the number that actually differentiates outlets.
// const COMBO_SORT_KEY_MAP = COMBO_COLUMN_DEFS.reduce((acc, combo) => {
//     acc[combo.key] = combo.amountKey;
//     return acc;
// }, {});

// const COMBO_KEYS_TO_HIDE = new Set(COMBO_COLUMN_DEFS.flatMap((combo) => combo.replaces));
// const COMBO_BY_INSERT_KEY = COMBO_COLUMN_DEFS.reduce((acc, combo) => {
//     acc[combo.insertAfterKey] = combo;
//     return acc;
// }, {});

// const hasAnyValue = (source, keys) =>
//     keys.some((k) => source?.[k] !== undefined && source?.[k] !== null);

// // Per-outlet Zomato/Swiggy amounts live in a nested array on the outlet
// // object: outlet.thirdPartySalesByPlatform = [{ platform: "ZOMATO",
// // totalSales, totalDiscount, totalPrice, outlet, outletId }, ...]. This
// // array is only present on outlets that actually had orders from that
// // platform. We look there first, then fall back to legacy flat fields in
// // case the API shape changes.
// //
// // `field` lets callers choose which figure to pull per platform entry:
// //   - "totalSales" — net-of-discount amount (feeds Total/Grand Sales)
// //   - "totalPrice" — gross amount before discount (feeds Net Sales)
// const getPlatformSalesFromArray = (arr, platformName, field = "totalSales") => {
//     const entry = (arr || []).find((p) => (p?.platform || "").toUpperCase() === platformName);
//     return Number(entry?.[field]) || 0;
// };

// const getZomatoRevenue = (source, field = "totalSales") =>
//     getPlatformSalesFromArray(source?.thirdPartySalesByPlatform, "ZOMATO", field) ||
//     Number(source?.zomatoNetSaleRevenue ?? source?.zomatoRevenue) ||
//     0;

// const getSwiggyRevenue = (source, field = "totalSales") =>
//     getPlatformSalesFromArray(source?.thirdPartySalesByPlatform, "SWIGGY", field) ||
//     Number(source?.swiggyNetSaleRevenue ?? source?.swiggyRevenue) ||
//     0;

// // NEW: pull a platform's total sales figure out of the
// // `thirdPartySalesByPlatform` array returned alongside outletSales /
// // totalRevenueOfAllOutlets. This array is response-level (not per outlet),
// // so it can only feed the "Total (All Outlets)" row — see
// // `thirdPartyTotals` below. `field` works the same way as in
// // getPlatformSalesFromArray above.
// const getPlatformTotal = (thirdPartySalesByPlatform, platformName, field = "totalSales") => {
//     const entry = (thirdPartySalesByPlatform || []).find(
//         (p) => (p?.platform || "").toUpperCase() === platformName
//     );
//     return Number(entry?.[field]) || 0;
// };

// const formatCardValue = (val, isCount = false) => {
//     if (val === undefined || val === null) return isCount ? "0" : "₹0.00";
//     const num = Number(val);
//     if (isCount) return num.toLocaleString("en-IN");
//     return `₹${num.toLocaleString("en-IN", {
//         minimumFractionDigits: 2,
//         maximumFractionDigits: 2,
//     })}`;
// };

// // Shared amount/count formatters (also used by the combo-column cells).
// const formatAmountValue = (val) =>
//     `₹${(Number(val) || 0).toLocaleString("en-IN", {
//         minimumFractionDigits: 2,
//         maximumFractionDigits: 2,
//     })}`;

// const formatCountValue = (val) => {
//     const num = Number(val) || 0;
//     return Number.isInteger(num) ? num.toLocaleString("en-IN") : num.toFixed(0);
// };

// const getDefaultStartDate = () => {
//     const d = new Date();
//     d.setDate(d.getDate() - 91);
//     return d;
// };

// const toLocalDateStr = (d) => {
//     const pad = (n) => String(n).padStart(2, "0");
//     return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
// };

// const inclusiveDayCount = (start, end) => {
//     const diff = Math.floor((end - start) / (1000 * 60 * 60 * 24));
//     return diff + 1; // start date counts as Day 1
// };

// // Predictable per-column widths so the grid never reflows unexpectedly.
// // Outlet Name gets real room since it's the row's anchor; amount columns
// // get a bit more width than counts to avoid wrapping on long rupee values.
// const getColumnWidth = (col) => {
//     if (col.key === "outletName") return 252;
//     if (col.type === "combo") return 176;
//     if (col.type === "amount") return col.label.length > 20 ? 224 : 152;
//     if (col.type === "count") return 132;
//     return 160;
// };

// // Summary cards: Total Sales / Net Sales / App Sales stay as their own cards.
// // The Kiosk / Quick Order / Quick Serve breakdown now lives together inside
// // a single "Outlet Sales" card (see OUTLET_SALES_ITEMS below).
// const SUMMARY_CARDS = [
//     {
//         key: "totalRevenue",
//         label: "Total Sales",
//         icon: "bi-currency-rupee",
//         accent: "#f97316",
//         bg: "#FFF5EC",
//         shape: "coin",
//     },
//     {
//         key: "netSaleRevenue",
//         label: "Net Sales",
//         icon: "bi-receipt-cutoff",
//         accent: "#10b981",
//         bg: "#ECFFF7",
//         shape: "bag",
//     },
//     {
//         key: "appNetSaleRevenue",
//         label: "App Sales",
//         icon: "bi-phone",
//         accent: "#6d28d9",
//         bg: "#F3F0FF",
//         shape: "gift",
//     },
// ];

// // The combined card's own header styling (matches the look of the other
// // summary cards, but each row below gets its own icon + accent so the card
// // doesn't read as one flat block of teal).
// const OUTLET_SALES_CARD = {
//     label: "Outlet Sales",
//     accent: "#0f172a",
//     // bg: "linear-gradient(155deg,#F4FBFB 0%,#EAF7F8 55%,#E3F6F1 100%)",
//    bg:" rgb(238, 247, 255)"
// };

// // The individual channel rows listed by name inside that card.
// const OUTLET_SALES_ITEMS = [
//     {
//         key: "kioskNetSale",
//         countKey: "kioskOrders",
//         label: "Kiosk",
//         // icon: "bi-display",
//         accent: "#2563eb",
//     },
//     {
//         key: "totalQuickOrderNetSaleRevenue",
//         countKey: "totalQuickOrderNetSaleCount",
//         label: "Qr Web Orders",
//         // icon: "bi-lightning-charge-fill",
//         accent: "#d97706",
//     },
//     {
//         key: "totalQuickServeNetSaleRevenue",
//         countKey: "totalQuickServeNetSaleCount",
//         label: "Walk In",
//         // icon: "bi-cup-hot-fill",
//         accent: "#0f766e",
//     },
// ];

// const ReeloShape = ({ type, accent }) => {
//     const common = {
//         position: "absolute",
//         right: -12,
//         bottom: -20,
//         width: 118,
//         height: 118,
//         opacity: 0.92,
//         pointerEvents: "none",
//     };

//     if (type === "coin") {
//         return (
//             <div style={common}>
//                 <div
//                     style={{
//                         width: 96,
//                         height: 96,
//                         borderRadius: "50%",
//                         background: "linear-gradient(135deg,#ffd27a,#f59e0b)",
//                         boxShadow: "inset -12px -12px 18px rgba(140,74,0,.22)",
//                         display: "grid",
//                         placeItems: "center",
//                         transform: "rotate(-18deg)",
//                     }}
//                 >
//                     <span style={{ fontSize: 42, fontWeight: 900, color: "#fff7df" }}>₹</span>
//                 </div>
//             </div>
//         );
//     }

//     if (type === "bag") {
//         return (
//             <div style={common}>
//                 <div
//                     style={{
//                         width: 86,
//                         height: 76,
//                         borderRadius: "12px 12px 22px 22px",
//                         background: "linear-gradient(135deg,#ff8a00,#ef4444)",
//                         marginTop: 28,
//                         transform: "rotate(2deg)",
//                     }}
//                 />
//                 <div
//                     style={{
//                         position: "absolute",
//                         top: 18,
//                         left: 26,
//                         width: 42,
//                         height: 36,
//                         border: "7px solid rgba(255,255,255,.75)",
//                         borderBottom: 0,
//                         borderRadius: "24px 24px 0 0",
//                     }}
//                 />
//             </div>
//         );
//     }

//     if (type === "gift") {
//         return (
//             <div style={common}>
//                 <div
//                     style={{
//                         width: 92,
//                         height: 72,
//                         marginTop: 26,
//                         borderRadius: 14,
//                         background: "linear-gradient(135deg,#7c3aed,#ef4444)",
//                         transform: "rotate(-10deg)",
//                     }}
//                 />
//                 <div
//                     style={{
//                         position: "absolute",
//                         top: 25,
//                         left: 42,
//                         width: 13,
//                         height: 75,
//                         background: "rgba(255,220,120,.9)",
//                         transform: "rotate(-10deg)",
//                     }}
//                 />
//                 <div
//                     style={{
//                         position: "absolute",
//                         top: 52,
//                         left: 4,
//                         width: 92,
//                         height: 12,
//                         background: "rgba(255,220,120,.9)",
//                         transform: "rotate(-10deg)",
//                     }}
//                 />
//             </div>
//         );
//     }

//     return (
//         <div style={common}>
//             <div
//                 style={{
//                     width: 62,
//                     height: 62,
//                     borderRadius: "50%",
//                     background: "linear-gradient(135deg,#ffd0c2,#9b5b44)",
//                     marginLeft: 34,
//                 }}
//             />
//             <div
//                 style={{
//                     width: 96,
//                     height: 82,
//                     borderRadius: "48px 48px 18px 18px",
//                     background: `linear-gradient(135deg,${accent},#f97316)`,
//                     marginTop: -4,
//                     marginLeft: 12,
//                 }}
//             />
//         </div>
//     );
// };

// const OutletRevenueKpi = ({ outletFilter, loadingOutlets }) => {
//     const token = localStorage.getItem("authToken");
//     const navigate = useNavigate();

//     const [viewMode, setViewMode] = useState("list");
//     const [filterType, setFilterType] = useState("totalSales");
//     const [sortType, setSortType] = useState("-1");
//     const [dateFilter, setDateFilter] = useState("today");
//     const [outletData, setOutletData] = useState([]);
//     const [totalsData, setTotalsData] = useState(null);
//     // NEW: response-level Zomato/Swiggy platform totals, e.g.
//     // [{ platform: "ZOMATO", totalSales: 3648.2, totalDiscount: 0, totalPrice: 3648.2 }, ...]
//     const [thirdPartySalesByPlatform, setThirdPartySalesByPlatform] = useState([]);
//     // NEW: whether the "Net Sales" summary card is flipped to show the
//     // "incl. Zomato/Swiggy" figure instead of the plain net sales figure.
//     const [showNetSalesIncl, setShowNetSalesIncl] = useState(false);
//     // NEW: whether the "Total Sales" summary card is flipped to show the
//     // "incl. Zomato/Swiggy" (Grand Total) figure instead of the plain
//     // total sales figure.
//     const [showTotalSalesIncl, setShowTotalSalesIncl] = useState(false);
//     const [loading, setLoading] = useState(true);
//     const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

//     const [customStartDate, setCustomStartDate] = useState(getDefaultStartDate);
//     const [customEndDate, setCustomEndDate] = useState(() => new Date());
//     const [customDateError, setCustomDateError] = useState("");
//     const [appliedCustomRange, setAppliedCustomRange] = useState(null);

//     const [openViewModal, setOpenViewModal] = useState(false);
//     const [viewModalLoading, setViewModalLoading] = useState(false);
//     const [viewModalData, setViewModalData] = useState(null);
//     const [selectedOutletName, setSelectedOutletName] = useState("");

//     // ---- Table UX-only state (does not touch data/business logic) ----
//     const [tableScrolledLeft, setTableScrolledLeft] = useState(false); // scrolled away from the start
//     const [canScrollRight, setCanScrollRight] = useState(false); // more columns hidden to the right
//     const [columnVisibility, setColumnVisibility] = useState({}); // { [colKey]: boolean }
//     const [showColumnMenu, setShowColumnMenu] = useState(false);

//     const tableWrapRef = useRef(null);
//     const columnMenuRef = useRef(null);
//     const scrollRafRef = useRef(null);

//     const currentFilterOption = FILTER_OPTIONS.find((f) => f.value === filterType) || FILTER_OPTIONS[0];
//     const currentDataKey = currentFilterOption.dataKey;
//     const selectedFilterLabel = currentFilterOption.label;
//     const isAmount = currentDataKey !== "totalOrders";

//     // Zomato / Swiggy columns only show up once the response actually
//     // contains that platform's data (i.e. at least one outlet took an order
//     // from that channel, or the totals row already reflects it). This is
//     // the RAW column set — every numeric field gets summed into
//     // `calculatedTotals` from this list, regardless of what's merged for
//     // display below.
//     const tableColumns = useMemo(() => {
//         const visibleOptional = OPTIONAL_TABLE_COLUMNS.filter(
//             (col) =>
//                 outletData.some(
//                     (o) =>
//                         hasAnyValue(o, col.presenceKeys) ||
//                         // NEW: also match the nested per-outlet array shape,
//                         // e.g. outlet.thirdPartySalesByPlatform = [{ platform: "ZOMATO", totalSales }]
//                         (col.platformName && getPlatformSalesFromArray(o?.thirdPartySalesByPlatform, col.platformName) > 0)
//                 ) || hasAnyValue(totalsData, col.presenceKeys)
//         );
//         return [...BASE_TABLE_COLUMNS, ...visibleOptional];
//     }, [outletData, totalsData]);

//     // Presentation-only: walk the raw columns and swap the Quick Order /
//     // Quick Serve count+revenue pairs for a single combined column, in the
//     // same position the revenue column used to occupy. Nothing here feeds
//     // calculatedTotals — that still reduces over `tableColumns` above.
//     const displayColumns = useMemo(() => {
//         const result = [];
//         tableColumns.forEach((col) => {
//             if (COMBO_KEYS_TO_HIDE.has(col.key)) {
//                 const combo = COMBO_BY_INSERT_KEY[col.key];
//                 if (combo) result.push(combo);
//                 return;
//             }
//             result.push(col);
//         });
//         return result;
//     }, [tableColumns]);

//     // Column-manager visibility is presentation-only: it never touches
//     // `tableColumns`, so totals/business logic keep seeing every column
//     // regardless of what the user has hidden from `displayColumns`.
//     useEffect(() => {
//         setColumnVisibility((prev) => {
//             let changed = false;
//             const next = { ...prev };
//             displayColumns.forEach((col) => {
//                 if (!(col.key in next)) {
//                     next[col.key] = true;
//                     changed = true;
//                 }
//             });
//             return changed ? next : prev;
//         });
//     }, [displayColumns]);

//     const visibleTableColumns = useMemo(
//         () => displayColumns.filter((col) => col.key === "outletName" || columnVisibility[col.key] !== false),
//         [displayColumns, columnVisibility]
//     );

//     const tableMinWidth = useMemo(
//         () => visibleTableColumns.reduce((sum, col) => sum + getColumnWidth(col), 0),
//         [visibleTableColumns]
//     );

//     const fetchOutletRevenueStats = useCallback(async () => {
//         try {
//             setLoading(true);

//             let url = `dashboard/getAllOutletRevenueStats?filter=${filterType}&sort=${sortType}`;

//             if (dateFilter === "custom" && appliedCustomRange) {
//                 url += `&startDate=${appliedCustomRange.start}&endDate=${appliedCustomRange.end}`;
//             } else {
//                 url += `&dateFilter=${dateFilter}`;
//             }

//             if (outletFilter && outletFilter !== "all") {
//                 url += `&outletId=${outletFilter}`;
//             }

//             const response = await axiosInstance.get(url, {
//                 headers: { Authorization: `Bearer ${token}` },
//             });

//             if (response?.data?.status === true) {
//                 const inner = response?.data?.data?.data;
//                 setOutletData(inner?.outletSales || []);
//                 setTotalsData(inner?.totalRevenueOfAllOutlets || null);
//                 // NEW: capture the platform-level Zomato/Swiggy totals
//                 setThirdPartySalesByPlatform(inner?.thirdPartySalesByPlatform || []);
//             }
//         } catch (error) {
//             console.error("Error fetching outlet revenue stats:", error);
//         } finally {
//             setLoading(false);
//         }
//     }, [token, filterType, sortType, dateFilter, outletFilter, appliedCustomRange]);

//     useEffect(() => {
//         fetchOutletRevenueStats();
//     }, [fetchOutletRevenueStats]);

//     // NEW: Zomato + Swiggy totals pulled from `thirdPartySalesByPlatform`.
//     // This array is response-level, not per outlet, so it can only be
//     // applied to the "Total (All Outlets)" row — see formatTotalCell below.
//     //
//     // Two different platform figures are summed here because they feed two
//     // different KPIs:
//     //   - salesCombined (field "totalSales", net-of-discount) feeds
//     //     Grand Total  = App Grandtotal (Total Sales) + Third Party (totalSales)
//     //   - priceCombined (field "totalPrice", gross-of-discount) feeds
//     //     Net Sales    = App Taxable (Net Sales) + Third Party (totalPrice)
//     const thirdPartyTotals = useMemo(() => {
//         const zomatoSales = getPlatformTotal(thirdPartySalesByPlatform, "ZOMATO", "totalSales");
//         const swiggySales = getPlatformTotal(thirdPartySalesByPlatform, "SWIGGY", "totalSales");
//         const zomatoPrice = getPlatformTotal(thirdPartySalesByPlatform, "ZOMATO", "totalPrice");
//         const swiggyPrice = getPlatformTotal(thirdPartySalesByPlatform, "SWIGGY", "totalPrice");
//         return {
//             zomato: zomatoSales,
//             swiggy: swiggySales,
//             combined: zomatoSales + swiggySales, // kept for backward-compat
//             salesCombined: zomatoSales + swiggySales,
//             priceCombined: zomatoPrice + swiggyPrice,
//         };
//     }, [thirdPartySalesByPlatform]);

//     // Enrich outlet data with calculated fields, including net sales that
//     // folds Zomato + Swiggy revenue into the outlet's own net sales figure.
//     // NOTE: per-outlet Zomato/Swiggy revenue is only available if the API
//     // puts it directly on each outlet row (zomatoNetSaleRevenue /
//     // zomatoRevenue / swiggyNetSaleRevenue / swiggyRevenue). The
//     // response-level `thirdPartySalesByPlatform` array is NOT split by
//     // outlet, so it cannot be attributed to individual rows here — only to
//     // the Total row (see thirdPartyTotals + formatTotalCell).
//     const processedOutletData = useMemo(
//         () =>
//             outletData.map((outlet) => ({
//                 ...outlet,
//                 netOrders: (Number(outlet.totalOrders) || 0) - (Number(outlet.cancelledOrders) || 0),
//                 netAppOrders: (Number(outlet.appOrders) || 0) - (Number(outlet.cancelledAppOrders) || 0),
//                 netKioskOrders: (Number(outlet.kioskOrders) || 0) - (Number(outlet.cancelledKioskOrders) || 0),
//                 // NEW: Gross Sales = Total Sales + Zomato (totalSales) + Swiggy (totalSales)
//                 grossSales:
//                     (Number(outlet.totalRevenue) || 0) +
//                     getZomatoRevenue(outlet) +
//                     getSwiggyRevenue(outlet),
//                 // NEW: Offline Sales = Quick Order Revenue + Quick Serve Revenue
//                 offlineSales:
//                     (Number(outlet.totalQuickOrderNetSaleRevenue) || 0) +
//                     (Number(outlet.totalQuickServeNetSaleRevenue) || 0),
//                 // Net Sales (incl. Zomato/Swiggy) = Net Sales + Third Party (totalPrice)
//                 netSalesInclThirdParty:
//                     (Number(outlet.netSaleRevenue) || 0) +
//                     getZomatoRevenue(outlet, "totalPrice") +
//                     getSwiggyRevenue(outlet, "totalPrice"),
//             })),
//         [outletData]
//     );

//     const calculatedTotals = useMemo(() => {
//         const acc = processedOutletData.reduce((a, outlet) => {
//             tableColumns.forEach((col) => {
//                 if (col.isNumeric) {
//                     // NEW: Zomato/Swiggy revenue columns don't exist as flat
//                     // fields on the outlet — pull them from the nested
//                     // thirdPartySalesByPlatform array instead.
//                     const rawVal = col.platformName
//                         ? getPlatformSalesFromArray(outlet?.thirdPartySalesByPlatform, col.platformName)
//                         : outlet[col.key] ?? (col.fallbackKey ? outlet[col.fallbackKey] : undefined);
//                     a[col.key] = (a[col.key] || 0) + (Number(rawVal) || 0);
//                 }
//             });
//             return a;
//         }, {});
//         acc.netOrders = (acc.totalOrders || 0) - (acc.cancelledOrders || 0);
//         // Sum of each outlet's own netSalesInclThirdParty. This already
//         // includes that outlet's Zomato/Swiggy revenue (via
//         // getZomatoRevenue/getSwiggyRevenue reading the nested
//         // thirdPartySalesByPlatform array in processedOutletData above), so
//         // it should NOT also add thirdPartyTotals.priceCombined again — that
//         // would double-count the same amounts.
//         acc.netSalesInclThirdParty = processedOutletData.reduce(
//             (sum, outlet) => sum + (Number(outlet.netSalesInclThirdParty) || 0),
//             0
//         );
//         // Sum of each outlet's own grossSales (Total Sales + Zomato/Swiggy
//         // totalSales). Same double-count guard as netSalesInclThirdParty
//         // above — the per-outlet field already folds in third-party amounts.
//         acc.grossSales = processedOutletData.reduce(
//             (sum, outlet) => sum + (Number(outlet.grossSales) || 0),
//             0
//         );
//         // Sum of each outlet's own offlineSales (Quick Order + Quick Serve).
//         acc.offlineSales = processedOutletData.reduce(
//             (sum, outlet) => sum + (Number(outlet.offlineSales) || 0),
//             0
//         );
//         return acc;
//     }, [processedOutletData, tableColumns]);

//     // NEW: Net Sales = App Taxable (netSaleRevenue) + Third Party
//     // (totalPrice), for the back face of the flippable "Net Sales" summary
//     // card. Mirrors the same figure shown in the "Net Sales (incl.
//     // Zomato/Swiggy)" table total column.
//     const netSalesInclThirdPartyTotal = useMemo(() => {
//         const baseNet = Number(totalsData?.netSaleRevenue ?? calculatedTotals?.netSaleRevenue ?? 0);
//         return baseNet + thirdPartyTotals.priceCombined;
//     }, [totalsData, calculatedTotals, thirdPartyTotals]);

//     // NEW: Grand Total = App Grandtotal (totalRevenue) + Third Party
//     // (totalSales), for the back face of the flippable "Total Sales"
//     // summary card. This is also the "Gross Sales" total-row figure.
//     const totalSalesInclThirdPartyTotal = useMemo(() => {
//         const baseTotal = Number(totalsData?.totalRevenue ?? calculatedTotals?.totalRevenue ?? 0);
//         return baseTotal + thirdPartyTotals.salesCombined;
//     }, [totalsData, calculatedTotals, thirdPartyTotals]);

//     const truncateName = (name, maxLen = 14) =>
//         name?.length > maxLen ? `${name.slice(0, maxLen)}...` : name;

//     const chartData = useMemo(() => {
//         let data = processedOutletData.map((outlet) => ({
//             name: truncateName(outlet?.outletName || ""),
//             fullName: outlet?.outletName || "",
//             value: Number(outlet?.[currentDataKey]) || 0,
//         }));

//         if (filterType === "orders") {
//             data = [...data].sort((a, b) => (sortType === "-1" ? b.value - a.value : a.value - b.value));
//         }

//         return data;
//     }, [processedOutletData, currentDataKey, filterType, sortType]);

//     const sortedData = useMemo(
//         () =>
//             [...processedOutletData].sort((a, b) => {
//                 if (!sortConfig.key) return 0;

//                 // Combo columns (Quick Order / Quick Serve) sort by their
//                 // revenue field — that's the number that actually
//                 // differentiates outlets.
//                 const effectiveKey = COMBO_SORT_KEY_MAP[sortConfig.key] || sortConfig.key;

//                 const valA = a?.[effectiveKey] ?? 0;
//                 const valB = b?.[effectiveKey] ?? 0;

//                 if (typeof valA === "string") {
//                     return sortConfig.direction === "asc"
//                         ? valA.localeCompare(valB)
//                         : valB.localeCompare(valA);
//                 }

//                 return sortConfig.direction === "asc" ? valA - valB : valB - valA;
//             }),
//         [processedOutletData, sortConfig]
//     );

//     const handleApplyCustomRange = () => {
//         if (!customStartDate || !customEndDate) {
//             setCustomDateError("Please select both dates.");
//             return;
//         }

//         const diffDays = inclusiveDayCount(customStartDate, customEndDate);

//         if (diffDays > 90) {
//             setCustomDateError("Range cannot exceed 90 days.");
//             return;
//         }

//         setCustomDateError("");
//         setAppliedCustomRange({
//             start: toLocalDateStr(customStartDate),
//             end: toLocalDateStr(customEndDate),
//         });
//     };

//     const handleViewModal = (col, outlet) => {
//         navigate(`/dashboard/outlet-details/${outlet?._id}`, {
//             state: {
//                 outletName: outlet?.outletName,
//                 dateFilter,
//                 customRange: appliedCustomRange,
//             },
//         });
//     };

//     const getOutletOrdersDetails = async (outletId, dateF) => {
//         try {
//             setViewModalLoading(true);
//             const headers = { Authorization: `Bearer ${token}` };

//             let url = `/dashboard/getRevenueStatThroughSummaryByOutlet?outletId=${outletId}`;

//             if (dateF === "custom" && appliedCustomRange) {
//                 url += `&filterType=custom&startDate=${appliedCustomRange.start}&endDate=${appliedCustomRange.end}`;
//             } else {
//                 url += `&filterType=${dateFilter}`;
//             }

//             const response = await axiosInstance.get(url, { headers });
//             setViewModalData(response?.data?.data);
//         } catch (error) {
//             console.log("Error in Getting Outlet Order Details :", error);
//         } finally {
//             setViewModalLoading(false);
//         }
//     };

//     const getNetOrdersTotal = () => {
//         const total = totalsData?.totalOrders ?? calculatedTotals?.totalOrders ?? 0;
//         const cancelled = totalsData?.cancelledOrders ?? calculatedTotals?.cancelledOrders ?? 0;
//         return total - cancelled;
//     };

//     const handleTableSort = (key) => {
//         setSortConfig((prev) => ({
//             key,
//             direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc",
//         }));
//     };

//     const formatCell = (col, outlet) => {
//         let val = outlet?.[col.key];
//         if (val === undefined || val === null) {
//             val = col.fallbackKey ? outlet?.[col.fallbackKey] : val;
//         }

//         // NEW: Zomato/Swiggy revenue columns are sourced from the nested
//         // per-outlet thirdPartySalesByPlatform array, not a flat field.
//         if (col.platformName) {
//             val = getPlatformSalesFromArray(outlet?.thirdPartySalesByPlatform, col.platformName);
//         }

//         if (col.key === "netOrders") {
//             val = (Number(outlet?.totalOrders) || 0) - (Number(outlet?.cancelledOrders) || 0);
//         }

//         if (!col.isNumeric) return val || "—";

//         if (val === undefined || val === null) {
//             return col.type === "amount" ? "₹0.00" : "0";
//         }

//         if (col.type === "amount") {
//             return formatAmountValue(val);
//         }

//         return formatCountValue(val);
//     };

//     const formatTotalCell = (col) => {
//         if (!col.isNumeric) return "—";

//         // NEW: "Gross Sales" total = Total Sales total + Zomato/Swiggy
//         // (totalSales) platform totals — same figure as the Total Sales
//         // card's flipped-back value.
//         if (col.key === "grossSales") {
//             return formatAmountValue(totalSalesInclThirdPartyTotal);
//         }

//         // NEW: "Offline Sales" total = Quick Order Revenue total + Quick
//         // Serve Revenue total.
//         if (col.key === "offlineSales") {
//             const quickOrderTotal =
//                 totalsData?.totalQuickOrderNetSaleRevenue ?? calculatedTotals?.totalQuickOrderNetSaleRevenue ?? 0;
//             const quickServeTotal =
//                 totalsData?.totalQuickServeNetSaleRevenue ?? calculatedTotals?.totalQuickServeNetSaleRevenue ?? 0;
//             return formatAmountValue(Number(quickOrderTotal) + Number(quickServeTotal));
//         }

//         // NEW: "Net Sales (incl. Zomato/Swiggy)" total = App Taxable (base
//         // Net Sales) total + the response-level Zomato/Swiggy "totalPrice"
//         // platform totals. This takes priority over the generic
//         // totalsData/calculatedTotals lookup below because the API's own
//         // `totalsData` object doesn't include the third-party amounts.
//         if (col.key === "netSalesInclThirdParty") {
//             const baseNet = Number(totalsData?.netSaleRevenue ?? calculatedTotals?.netSaleRevenue ?? 0);
//             const val = baseNet + thirdPartyTotals.priceCombined;
//             return formatAmountValue(val);
//         }

//         let val =
//             totalsData?.[col.key] ??
//             (col.fallbackKey ? totalsData?.[col.fallbackKey] : undefined) ??
//             calculatedTotals?.[col.key];

//         if (col.key === "netOrders") {
//             const netOrders =
//                 (totalsData?.totalOrders ?? calculatedTotals?.totalOrders ?? 0) -
//                 (totalsData?.cancelledOrders ?? calculatedTotals?.cancelledOrders ?? 0);

//             return netOrders.toLocaleString("en-IN");
//         }

//         if (val === undefined || val === null) {
//             return col.type === "amount" ? "₹0.00" : "0";
//         }

//         if (col.type === "amount") {
//             return formatAmountValue(val);
//         }

//         return formatCountValue(val);
//     };

//     // Combo cells (Quick Order / Quick Serve): revenue on top, count
//     // underneath as a lighter secondary line. `source` is an outlet row for
//     // body cells, or null (falls back to totalsData/calculatedTotals) for
//     // the Total row.
//     const renderComboCell = (col, source) => {
//         const amountVal = source
//             ? source?.[col.amountKey]
//             : totalsData?.[col.amountKey] ?? calculatedTotals?.[col.amountKey];
//         const countVal = source
//             ? source?.[col.countKey]
//             : totalsData?.[col.countKey] ?? calculatedTotals?.[col.countKey];

//         return (
//             <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", lineHeight: 1.3 }}>
//                 <span style={{ fontWeight: 800 }}>{formatAmountValue(amountVal)}</span>
//                 <span style={{ fontSize: 11, fontWeight: 700, color: "#94a3b8" }}>
//                     {formatCountValue(countVal)} orders
//                 </span>
//             </div>
//         );
//     };

//     // ---- Horizontal/vertical scroll UX helpers (presentation-only) ----

//     const updateScrollState = useCallback((el) => {
//         if (!el) return;
//         const { scrollLeft, scrollWidth, clientWidth } = el;
//         setTableScrolledLeft(scrollLeft > 2);
//         setCanScrollRight(scrollWidth - clientWidth - scrollLeft > 2);
//     }, []);

//     const handleTableScroll = useCallback(
//         (e) => {
//             const el = e.currentTarget;
//             if (scrollRafRef.current) return;
//             scrollRafRef.current = requestAnimationFrame(() => {
//                 updateScrollState(el);
//                 scrollRafRef.current = null;
//             });
//         },
//         [updateScrollState]
//     );

//     // Re-check whenever the visible column set or row count changes the
//     // table's natural width (e.g. after fetch, sort, or column toggling).
//     useEffect(() => {
//         const el = tableWrapRef.current;
//         if (!el) return;
//         updateScrollState(el);
//     }, [visibleTableColumns, sortedData, tableMinWidth, updateScrollState]);

//     useEffect(() => {
//         return () => {
//             if (scrollRafRef.current) cancelAnimationFrame(scrollRafRef.current);
//         };
//     }, []);

//     const scrollTableBy = (delta) => {
//         const el = tableWrapRef.current;
//         if (!el) return;
//         el.scrollBy({ left: delta, behavior: "smooth" });
//     };

//     // Close the column-manager popover on outside click.
//     useEffect(() => {
//         if (!showColumnMenu) return undefined;

//         const handleClickOutside = (event) => {
//             if (columnMenuRef.current && !columnMenuRef.current.contains(event.target)) {
//                 setShowColumnMenu(false);
//             }
//         };

//         document.addEventListener("mousedown", handleClickOutside);
//         return () => document.removeEventListener("mousedown", handleClickOutside);
//     }, [showColumnMenu]);

//     const toggleColumnVisibility = (key) => {
//         setColumnVisibility((prev) => ({ ...prev, [key]: prev[key] === false }));
//     };

//     const hiddenColumnCount = displayColumns.length - visibleTableColumns.length;

//     const CustomTooltip = ({ active, payload }) => {
//         if (!active || !payload?.length) return null;

//         const val = payload[0]?.value;
//         const isCount = !isAmount;

//         return (
//             <div
//                 style={{
//                     background: "#fff",
//                     border: "1px solid #dbe5e8",
//                     borderRadius: 14,
//                     padding: "10px 14px",
//                     boxShadow: "0 14px 34px rgba(15,23,42,.12)",
//                 }}
//             >
//                 <p className="mb-1 fw-semibold" style={{ fontSize: 13, color: "#0f172a" }}>
//                     {payload[0]?.payload?.fullName}
//                 </p>
//                 <p className="mb-0" style={{ fontSize: 13, color: "#2563eb" }}>
//                     {selectedFilterLabel}:{" "}
//                     <strong>
//                         {isCount
//                             ? Number(val).toLocaleString("en-IN")
//                             : `₹${Number(val).toLocaleString("en-IN", {
//                                 minimumFractionDigits: 2,
//                                 maximumFractionDigits: 2,
//                             })}`}
//                     </strong>
//                 </p>
//             </div>
//         );
//     };

//     return (
//         <Container fluid className="py-3" style={{ background: "#fff" }}>
//             <style>{`
//         .reelo-select {
//           border: 1px solid #d7e2e5 !important;
//           border-radius: 12px !important;
//           font-size: 13px !important;
//           font-weight: 700 !important;
//           color: #334155 !important;
//           box-shadow: none !important;
//           min-height: 42px;
//         }

//         .reelo-date-input,
//         .date-picker-wrapper input {
//           border: 1px solid #d7e2e5 !important;
//           border-radius: 10px !important;
//           height: 36px !important;
//           font-size: 12px !important;
//           font-weight: 600 !important;
//           color: #334155 !important;
//           box-shadow: none !important;
//         }

//         .reelo-table-wrap {
//           scrollbar-width: thin;
//           scrollbar-color: #a8dedb transparent;
//         }

//         .reelo-table-wrap::-webkit-scrollbar {
//           height: 8px;
//           width: 8px;
//         }

//         .reelo-table-wrap::-webkit-scrollbar-track {
//           background: transparent;
//         }

//         .reelo-table-wrap::-webkit-scrollbar-thumb {
//           background: #cfe4e2;
//           border-radius: 999px;
//         }

//         .reelo-table-wrap::-webkit-scrollbar-thumb:hover {
//           background: #0ea5a4;
//         }

//         .reelo-row:hover {
//           background: #f7fbfc !important;
//         }

//         .reelo-tab-btn {
//           border: 1px solid #d7e2e5 !important;
//           background: #fff !important;
//           color: #475569 !important;
//           font-weight: 800 !important;
//           font-size: 13px !important;
//           padding: 10px 18px !important;
//         }

//         .reelo-tab-btn.active {
//           background: #101820 !important;
//           color: #fff !important;
//           border-color: #101820 !important;
//         }

//         .reelo-thead-cell {
//           position: sticky;
//           top: 0;
//           z-index: 3;
//           background: #fbfcfd;
//         }

//         .reelo-sticky-col {
//           position: sticky;
//           left: 0;
//           z-index: 2;
//           background: inherit;
//           box-shadow: none;
//           transition: box-shadow .15s ease;
//         }

//         .is-scrolled-left .reelo-sticky-col {
//           box-shadow: 6px 0 12px -8px rgba(15,23,42,.30);
//         }

//         thead .reelo-sticky-col {
//           z-index: 4;
//           background: #fbfcfd;
//         }

//         .reelo-table-outer {
//           position: relative;
//         }

//         .reelo-scroll-edge {
//           position: absolute;
//           top: 0;
//           bottom: 0;
//           width: 64px;
//           pointer-events: none;
//           z-index: 5;
//           opacity: 0;
//           transition: opacity .18s ease;
//         }

//         .reelo-scroll-edge.visible {
//           opacity: 1;
//         }

//         .reelo-scroll-edge.edge-left {
//           left: 0;
//           background: linear-gradient(to right, rgba(255,255,255,.98), rgba(255,255,255,0));
//         }

//         .reelo-scroll-edge.edge-right {
//           right: 0;
//           background: linear-gradient(to left, rgba(255,255,255,.98), rgba(255,255,255,0));
//         }

//         .reelo-scroll-btn {
//           position: absolute;
//           top: 50%;
//           transform: translateY(-50%);
//           width: 32px;
//           height: 32px;
//           border-radius: 999px;
//           border: 1px solid #d7e2e5;
//           background: #fff;
//           color: #475569;
//           display: grid;
//           place-items: center;
//           font-size: 14px;
//           z-index: 6;
//           box-shadow: 0 6px 16px rgba(15,23,42,.12);
//           cursor: pointer;
//           opacity: 0;
//           pointer-events: none;
//           transition: opacity .18s ease, background .15s ease, color .15s ease, box-shadow .15s ease;
//         }

//         .reelo-scroll-btn.visible {
//           opacity: 1;
//           pointer-events: auto;
//         }

//         .reelo-scroll-btn.btn-left { left: 10px; }
//         .reelo-scroll-btn.btn-right { right: 10px; }

//         .reelo-scroll-btn:hover {
//           background: #101820;
//           color: #fff;
//           box-shadow: 0 10px 22px rgba(15,23,42,.22);
//         }

//         .reelo-col-menu-wrap {
//           position: relative;
//         }

//         .reelo-col-menu {
//           position: absolute;
//           top: calc(100% + 8px);
//           right: 0;
//           width: 272px;
//           max-height: 360px;
//           overflow-y: auto;
//           background: #fff;
//           border: 1px solid #dbe5e8;
//           border-radius: 14px;
//           box-shadow: 0 20px 44px rgba(15,23,42,.16);
//           padding: 8px;
//           z-index: 30;
//         }

//         .reelo-col-menu-title {
//           font-size: 11px;
//           font-weight: 900;
//           text-transform: uppercase;
//           letter-spacing: .5px;
//           color: #94a3b8;
//           padding: 8px 10px 4px;
//         }

//         .reelo-col-menu-item {
//           display: flex;
//           align-items: center;
//           gap: 10px;
//           padding: 8px 10px;
//           border-radius: 8px;
//           font-size: 13px;
//           font-weight: 600;
//           color: #334155;
//           cursor: pointer;
//         }

//         .reelo-col-menu-item:hover {
//           background: #f4fbff;
//         }

//         .reelo-col-menu-item.disabled {
//           opacity: .55;
//           cursor: not-allowed;
//         }

//         .reelo-col-menu-item input {
//           accent-color: #0ea5a4;
//           width: 15px;
//           height: 15px;
//         }

//         .outlet-sales-row {
//           display: flex;
//           align-items: center;
//           justify-content: space-between;
//           gap: 10px;
//           padding: 7px 0;
//           border-bottom: 1px dashed rgba(15,23,42,.07);
//         }

//         .outlet-sales-row:last-child {
//           border-bottom: none;
//         }

//         .net-sales-flip-outer {
//           perspective: 1200px;
//           cursor: pointer;
//           height: 100%;
//         }

//         .net-sales-flip-inner {
//           position: relative;
//           width: 100%;
//           height: 100%;
//           min-height: 118px;
//           transform-style: preserve-3d;
//           transition: transform .6s cubic-bezier(.4, .2, .2, 1);
//         }

//         .net-sales-flip-inner.is-flipped {
//           transform: rotateY(180deg);
//         }

//         .net-sales-flip-face {
//           position: absolute;
//           inset: 0;
//           backface-visibility: hidden;
//           -webkit-backface-visibility: hidden;
//           border-radius: 18px;
//           padding: 20px 22px;
//           border: 1px solid rgba(15,23,42,.04);
//           box-shadow: 0 8px 22px rgba(15,23,42,.05);
//           overflow: hidden;
//         }

//         .net-sales-flip-face.face-back {
//           transform: rotateY(180deg);
//         }

//         .net-sales-flip-hint {
//           font-size: 10px;
//           opacity: .55;
//         }
//       `}</style>

//             <div className="d-flex flex-wrap justify-content-between align-items-start gap-3 mb-4">
//                 <div>
//                     <div className="d-flex align-items-center gap-2 mb-1">
//                         <span
//                             style={{
//                                 width: 34,
//                                 height: 34,
//                                 borderRadius: 12,
//                                 background: "#EAF7F8",
//                                 color: "#0ea5a4",
//                                 display: "grid",
//                                 placeItems: "center",
//                                 fontSize: 18,
//                             }}
//                         >
//                             <i className="bi bi-bar-chart-line-fill" />
//                         </span>
//                         <h4 className="fw-bold mb-0" style={{ color: "#172126", letterSpacing: "-.4px" }}>
//                             Outlet Statistics
//                         </h4>
//                     </div>
//                     <p className="mb-0" style={{ color: "#708184", fontSize: 13, fontWeight: 500 }}>
//                         Sales, orders and outlet-wise performance summary
//                     </p>
//                 </div>

//                 <div
//                     className="d-flex align-items-center flex-wrap gap-2"
//                     style={{
//                         background: "#fff",
//                         border: "1px solid #dbe5e8",
//                         borderRadius: 18,
//                         padding: 8,
//                         boxShadow: "0 8px 22px rgba(15,23,42,.04)",
//                     }}
//                 >
//                     <div
//                         style={{
//                             width: 36,
//                             height: 36,
//                             borderRadius: 12,
//                             background: "#EAF7F8",
//                             color: "#0ea5a4",
//                             display: "grid",
//                             placeItems: "center",
//                         }}
//                     >
//                         <i className="bi bi-calendar-event" />
//                     </div>

//                     <div>

//                         <Form.Select
//                             value={dateFilter}
//                             onChange={(e) => {
//                                 const val = e.target.value;
//                                 setDateFilter(val);
//                                 setCustomDateError("");

//                                 if (val === "custom") {
//                                     const start = getDefaultStartDate();
//                                     const end = new Date();

//                                     setCustomStartDate(start);
//                                     setCustomEndDate(end);
//                                     setAppliedCustomRange({
//                                         start: toLocalDateStr(start),
//                                         end: toLocalDateStr(end),
//                                     });
//                                 } else {
//                                     setAppliedCustomRange(null);
//                                     setCustomStartDate(null);
//                                     setCustomEndDate(null);
//                                 }
//                             }}
//                             style={{ width: 155 }}
//                             className="reelo-select"
//                         >
//                             {DATE_FILTER_OPTIONS.map((opt) => (
//                                 <option key={opt.value} value={opt.value}>
//                                     {opt.label}
//                                 </option>
//                             ))}
//                         </Form.Select>

//                         {["last7days", "last30days", "thisMonth", "lastMonth"].includes(dateFilter) && (
//                             <span style={{ fontSize: 11, color: "#94a3b8", width: "100%", paddingLeft: 10 }}>
//                                 * Today's data not included
//                             </span>
//                         )}

//                     </div>

//                     {dateFilter === "custom" && (
//                         <div className="d-flex align-items-end gap-2 flex-wrap">
//                             <div>
//                                 <span classname="me-1" style={{ fontSize: 10, color: "#64748b", fontWeight: 700 }}>Start</span>
//                                 <DatePicker
//                                     selected={customStartDate}
//                                     onChange={(date) => {
//                                         setCustomStartDate(date);

//                                         if (date) {
//                                             const today = new Date();
//                                             const maxAllowedEnd = new Date(date);
//                                             maxAllowedEnd.setDate(maxAllowedEnd.getDate() + 89); // start date = Day 1, so +89 more = Day 90
//                                             const suggestedEnd = maxAllowedEnd > today ? today : maxAllowedEnd;

//                                             if (!customEndDate) {
//                                                 setCustomEndDate(suggestedEnd);
//                                             } else {
//                                                 const diff = inclusiveDayCount(date, customEndDate);
//                                                 if (diff > 90 || diff < 1) {
//                                                     setCustomEndDate(suggestedEnd);
//                                                 }
//                                             }
//                                         }
//                                         setCustomDateError("");
//                                     }}
//                                     selectsStart
//                                     startDate={customStartDate}
//                                     endDate={customEndDate}
//                                     maxDate={new Date()}
//                                     dateFormat="dd-MM-yyyy"
//                                     placeholderText="Start date"
//                                     className="form-control form-control-sm reelo-date-input"
//                                     wrapperClassName="date-picker-wrapper"
//                                     withPortal
//                                 />
//                             </div>

//                             <div>
//                                 <span className="me-1" style={{ fontSize: 10, color: "#64748b", fontWeight: 700 }}>End</span>
//                                 <DatePicker
//                                     selected={customEndDate}
//                                     onChange={(date) => {
//                                         setCustomEndDate(date);
//                                         setCustomDateError("");
//                                     }}
//                                     selectsEnd
//                                     startDate={customStartDate}
//                                     endDate={customEndDate}
//                                     minDate={customStartDate}
//                                     maxDate={
//                                         customStartDate
//                                             ? new Date(
//                                                 Math.min(
//                                                     new Date(customStartDate).setDate(customStartDate.getDate() + 89),
//                                                     new Date()
//                                                 )
//                                             )
//                                             : new Date()
//                                     }
//                                     disabled={!customStartDate}
//                                     dateFormat="dd-MM-yyyy"
//                                     placeholderText="End date"
//                                     className="form-control form-control-sm reelo-date-input"
//                                     wrapperClassName="date-picker-wrapper"
//                                     withPortal
//                                 />
//                             </div>

//                             <Button
//                                 size="sm"
//                                 onClick={handleApplyCustomRange}
//                                 disabled={!customStartDate || !customEndDate}
//                                 style={{
//                                     height: 36,
//                                     borderRadius: 10,
//                                     background: "#101820",
//                                     borderColor: "#101820",
//                                     fontWeight: 800,
//                                     paddingInline: 16,
//                                 }}
//                             >
//                                 Apply
//                             </Button>
//                         </div>
//                     )}

//                     {dateFilter === "custom" && customDateError && (
//                         <span style={{ fontSize: 11, color: "#dc2626", width: "100%", paddingLeft: 48 }}>
//                             ⚠ {customDateError}
//                         </span>
//                     )}

                    
//                 </div>
//             </div>

//             <div className="row g-3 mb-4">
//                 {SUMMARY_CARDS.map((card) => {
//                     const displayValue = totalsData?.[card.key] ?? calculatedTotals?.[card.key];

//                     // NEW: the "Total Sales" card is click-to-flip — front
//                     // face shows plain Total Sales (with the
//                     // cancelled/orders/complimentary context lines it had
//                     // before), back face shows the Grand Total figure:
//                     // Total Sales + Third Party (totalSales).
//                     if (card.key === "totalRevenue") {
//                         return (
//                             <div key={card.key} className="col-12 col-sm-6 col-xl-3">
//                                 <div
//                                     className="net-sales-flip-outer"
//                                     onClick={() => setShowTotalSalesIncl((prev) => !prev)}
//                                     role="button"
//                                     tabIndex={0}
//                                     aria-label="Toggle Total Sales figure to include Zomato/Swiggy"
//                                     onKeyDown={(e) => {
//                                         if (e.key === "Enter" || e.key === " ") {
//                                             e.preventDefault();
//                                             setShowTotalSalesIncl((prev) => !prev);
//                                         }
//                                     }}
//                                 >
//                                     <div className={`net-sales-flip-inner${showTotalSalesIncl ? " is-flipped" : ""}`}>
//                                         {/* Front face: plain Total Sales */}
//                                         <div className="net-sales-flip-face face-front" style={{ background: card.bg }}>
//                                             <ReeloShape type={card.shape} accent={card.accent} />
//                                             <div style={{ position: "relative", zIndex: 2 }}>
//                                                 <div
//                                                     className="d-flex align-items-center gap-2 mb-2"
//                                                     style={{ color: card.accent, fontSize: 15, fontWeight: 900 }}
//                                                 >
//                                                     <span>{card.label}</span>
//                                                     <i className="bi bi-arrow-repeat net-sales-flip-hint" />
//                                                 </div>

//                                                 {loading || loadingOutlets ? (
//                                                     <Spinner animation="border" size="sm" style={{ color: card.accent }} />
//                                                 ) : (
//                                                     <>
//                                                         {Number(
//                                                             totalsData?.totalCancelledOrderAmount ??
//                                                             calculatedTotals?.totalCancelledOrderAmount ??
//                                                             0
//                                                         ) > 0 && (
//                                                             <div style={{ fontSize: 12, fontWeight: 700, color: "#ef4444", marginBottom: 2 }}>
//                                                                 ₹
//                                                                 {Number(
//                                                                     totalsData?.totalCancelledOrderAmount ??
//                                                                     calculatedTotals?.totalCancelledOrderAmount ??
//                                                                     0
//                                                                 ).toLocaleString("en-IN", {
//                                                                     minimumFractionDigits: 2,
//                                                                     maximumFractionDigits: 2,
//                                                                 })}{" "}
//                                                                 / {Number(totalsData?.cancelledOrders ?? calculatedTotals?.cancelledOrders ?? 0)} Cancelled
//                                                             </div>
//                                                         )}

//                                                         <div
//                                                             style={{
//                                                                 fontSize: 26,
//                                                                 lineHeight: 1.1,
//                                                                 fontWeight: 900,
//                                                                 color: "#142124",
//                                                                 letterSpacing: "-.9px",
//                                                             }}
//                                                         >
//                                                             {formatCardValue(displayValue)}
//                                                         </div>

//                                                         <div style={{ fontSize: 12, fontWeight: 700, color: "#64748b", marginTop: 4 }}>
//                                                             {getNetOrdersTotal().toLocaleString("en-IN")} Orders
//                                                         </div>

//                                                         {/* Complimentary orders — not included inside
//                                                             totalOrders / the "Orders" line above. */}
//                                                         {Number(
//                                                             totalsData?.complimentaryOrders ??
//                                                             calculatedTotals?.complimentaryOrders ??
//                                                             0
//                                                         ) > 0 && (
//                                                             <div
//                                                                 style={{
//                                                                     fontSize: 11,
//                                                                     fontWeight: 700,
//                                                                     color: "#7c3aed",
//                                                                     marginTop: 3,
//                                                                     display: "flex",
//                                                                     alignItems: "center",
//                                                                     gap: 4,
//                                                                 }}
//                                                                 title="Complimentary orders are not counted in Total Orders"
//                                                             >
//                                                                 +
//                                                                 {Number(
//                                                                     totalsData?.complimentaryOrders ??
//                                                                     calculatedTotals?.complimentaryOrders ??
//                                                                     0
//                                                                 ).toLocaleString("en-IN")}{" "}
//                                                                 Complimentary
//                                                             </div>
//                                                         )}
//                                                     </>
//                                                 )}
//                                             </div>
//                                         </div>

//                                         {/* Back face: Grand Total = Total Sales + Third Party (totalSales) */}
//                                         <div className="net-sales-flip-face face-back" style={{ background: card.bg }}>
//                                             <ReeloShape type={card.shape} accent={card.accent} />
//                                             <div style={{ position: "relative", zIndex: 2 }}>
//                                                 <div
//                                                     className="d-flex align-items-center gap-2 mb-2"
//                                                     style={{ color: card.accent, fontSize: 13, fontWeight: 900 }}
//                                                 >
//                                                     <span>Total Sales (Incl Zomato / Swiggy)</span>
//                                                     <i className="bi bi-arrow-repeat net-sales-flip-hint" />
//                                                 </div>

//                                                 {loading || loadingOutlets ? (
//                                                     <Spinner animation="border" size="sm" style={{ color: card.accent }} />
//                                                 ) : (
//                                                     <div
//                                                         style={{
//                                                             fontSize: 24,
//                                                             lineHeight: 1.1,
//                                                             fontWeight: 900,
//                                                             color: "#142124",
//                                                             letterSpacing: "-.9px",
//                                                         }}
//                                                     >
//                                                         {formatCardValue(totalSalesInclThirdPartyTotal)}
//                                                     </div>
//                                                 )}
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         );
//                     }

//                     // NEW: the "Net Sales" card is click-to-flip — front face
//                     // shows plain Net Sales, back face shows Net Sales incl.
//                     // Zomato/Swiggy (totalPrice). Everything else about the
//                     // card (colors, shape, loading state) stays the same on
//                     // both faces.
//                     if (card.key === "netSaleRevenue") {
//                         return (
//                             <div key={card.key} className="col-12 col-sm-6 col-xl-3">
//                                 <div
//                                     className="net-sales-flip-outer"
//                                     onClick={() => setShowNetSalesIncl((prev) => !prev)}
//                                     role="button"
//                                     tabIndex={0}
//                                     aria-label="Toggle Net Sales figure to include Zomato/Swiggy"
//                                     onKeyDown={(e) => {
//                                         if (e.key === "Enter" || e.key === " ") {
//                                             e.preventDefault();
//                                             setShowNetSalesIncl((prev) => !prev);
//                                         }
//                                     }}
//                                 >
//                                     <div className={`net-sales-flip-inner${showNetSalesIncl ? " is-flipped" : ""}`}>
//                                         {/* Front face: plain Net Sales */}
//                                         <div className="net-sales-flip-face face-front" style={{ background: card.bg }}>
//                                             <ReeloShape type={card.shape} accent={card.accent} />
//                                             <div style={{ position: "relative", zIndex: 2 }}>
//                                                 <div
//                                                     className="d-flex align-items-center gap-2 mb-2"
//                                                     style={{ color: card.accent, fontSize: 15, fontWeight: 900 }}
//                                                 >
//                                                     <span>{card.label}</span>
//                                                     <i className="bi bi-arrow-repeat net-sales-flip-hint" />
//                                                 </div>

//                                                 {loading || loadingOutlets ? (
//                                                     <Spinner animation="border" size="sm" style={{ color: card.accent }} />
//                                                 ) : (
//                                                     <div
//                                                         style={{
//                                                             fontSize: 26,
//                                                             lineHeight: 1.1,
//                                                             fontWeight: 900,
//                                                             color: "#142124",
//                                                             letterSpacing: "-.9px",
//                                                         }}
//                                                     >
//                                                         {formatCardValue(displayValue)}
//                                                     </div>
//                                                 )}
//                                             </div>
//                                         </div>

//                                         {/* Back face: Net Sales + Third Party (totalPrice) */}
//                                         <div className="net-sales-flip-face face-back" style={{ background: card.bg }}>
//                                             <ReeloShape type={card.shape} accent={card.accent} />
//                                             <div style={{ position: "relative", zIndex: 2 }}>
//                                                 <div
//                                                     className="d-flex align-items-center gap-2 mb-2"
//                                                     style={{ color: card.accent, fontSize: 13, fontWeight: 900 }}
//                                                 >
//                                                     <span>Net Sales (Incl Zomato / Swiggy)</span>
//                                                     <i className="bi bi-arrow-repeat net-sales-flip-hint" />
//                                                 </div>

//                                                 {loading || loadingOutlets ? (
//                                                     <Spinner animation="border" size="sm" style={{ color: card.accent }} />
//                                                 ) : (
//                                                     <div
//                                                         style={{
//                                                             fontSize: 24,
//                                                             lineHeight: 1.1,
//                                                             fontWeight: 900,
//                                                             color: "#142124",
//                                                             letterSpacing: "-.9px",
//                                                         }}
//                                                     >
//                                                         {formatCardValue(netSalesInclThirdPartyTotal)}
//                                                     </div>
//                                                 )}
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         );
//                     }

//                     return (
//                         <div key={card.key} className="col-12 col-sm-6 col-xl-3">
//                             <div
//                                 className="position-relative overflow-hidden h-100"
//                                 style={{
//                                     borderRadius: 18,
//                                     background: card.bg,
//                                     minHeight: 118,
//                                     padding: "20px 22px",
//                                     border: "1px solid rgba(15,23,42,.04)",
//                                     boxShadow: "0 8px 22px rgba(15,23,42,.05)",
//                                 }}
//                             >
//                                 <ReeloShape type={card.shape} accent={card.accent} />

//                                 <div style={{ position: "relative", zIndex: 2 }}>
//                                     <div
//                                         className="d-flex align-items-center gap-2 mb-2"
//                                         style={{ color: card.accent, fontSize: 15, fontWeight: 900 }}
//                                     >
//                                         <span>{card.label}</span>
//                                     </div>

//                                     {loading || loadingOutlets ? (
//                                         <Spinner animation="border" size="sm" style={{ color: card.accent }} />
//                                     ) : (
//                                         <div
//                                             style={{
//                                                 fontSize: 26,
//                                                 lineHeight: 1.1,
//                                                 fontWeight: 900,
//                                                 color: "#142124",
//                                                 letterSpacing: "-.9px",
//                                             }}
//                                         >
//                                             {formatCardValue(displayValue)}
//                                         </div>
//                                     )}
//                                 </div>
//                             </div>
//                         </div>
//                     );
//                 })}

//                 {/* Combined Outlet Sales card: Kiosk / Quick Order / Quick Serve, each
//                     listed by name with its own icon, accent and order count. */}
//                 <div className="col-12 col-sm-6 col-xl-3">
//                     <div
//                         className="position-relative overflow-hidden h-100"
//                         style={{
//                             borderRadius: 18,
//                             background: OUTLET_SALES_CARD.bg,
//                             minHeight: 118,
//                             padding: "18px 20px",
//                             border: "1px solid rgba(15,23,42,.05)",
//                             boxShadow: "0 8px 22px rgba(15,23,42,.06)",
//                         }}
//                     >
//                         <div
//                             className="d-flex align-items-center gap-2 mb-3"
//                             style={{ color: OUTLET_SALES_CARD?.accent, fontSize: 15, fontWeight: 900 }}
//                         >
//                             {/* <span
//                                 style={{
//                                     width: 28,
//                                     height: 28,
//                                     borderRadius: 9,
//                                     background: "#0ea5a4",
//                                     color: "#fff",
//                                     display: "grid",
//                                     placeItems: "center",
//                                     fontSize: 14,
//                                     boxShadow: "0 4px 10px rgba(14,165,164,.35)",
//                                 }}
//                             >
//                                 <i className="bi bi-shop-window" />
//                             </span> */}
//                             <span style={{ color: "#2563EB" }}>{OUTLET_SALES_CARD.label}</span>
//                         </div>

//                         {loading || loadingOutlets ? (
//                             <Spinner animation="border" size="sm" style={{ color: OUTLET_SALES_CARD.accent }} />
//                         ) : (
//                             <div>
//                                 {OUTLET_SALES_ITEMS.map((item) => {
//                                     const displayValue = totalsData?.[item.key] ?? calculatedTotals?.[item.key];
//                                     const orderCount = totalsData?.[item.countKey] ?? calculatedTotals?.[item.countKey] ?? 0;

//                                     return (
//                                         <div key={item.key} className="outlet-sales-row p-1">
//                                             <div className="d-flex align-items-center gap-2">
//                                                 {/* <span
//                                                     style={{
//                                                         width: 26,
//                                                         height: 26,
//                                                         borderRadius: 8,
//                                                         background: "#fff",
//                                                         color: item.accent,
//                                                         display: "grid",
//                                                         placeItems: "center",
//                                                         fontSize: 12,
//                                                         flexShrink: 0,
//                                                         boxShadow: "0 2px 6px rgba(15,23,42,.08)",
//                                                     }}
//                                                 >
//                                                     <i className={`bi ${item.icon}`} />
//                                                 </span> */}
//                                                 <div>
//                                                     <div style={{ fontSize: 10.5, fontWeight: 800, color: "#334155" }}>
//                                                         {item.label} <span style={{ fontSize: 9.5, fontWeight: 700, color: "#94a3b8" }}>{Number(orderCount).toLocaleString("en-IN")} Orders</span>
//                                                     </div>
//                                                     {/* <div style={{ fontSize: 9.5, fontWeight: 700, color: "#94a3b8" }}>
//                                                         {Number(orderCount).toLocaleString("en-IN")} Orders
//                                                     </div> */}
//                                                 </div>
//                                             </div>

//                                             <span style={{ fontSize: 11.5, fontWeight: 900, color: "#142124" }}>
//                                                 {formatCardValue(displayValue)}
//                                             </span>
//                                         </div>
//                                     );
//                                 })}
//                             </div>
//                         )}
//                     </div>
//                 </div>
//             </div>

//             <div
//                 style={{
//                     border: "1px solid #cfdcdf",
//                     borderRadius: 18,
//                     background: "#fff",
//                     boxShadow: "0 10px 26px rgba(15,23,42,.04)",
//                     overflow: "hidden",
//                 }}
//             >
//                 <div
//                     className="d-flex justify-content-between align-items-center flex-wrap gap-3"
//                     style={{ padding: "20px 24px 12px" }}
//                 >
//                     <div>
//                         <div className="d-flex align-items-center gap-2">
//                             <i className="bi bi-rupee" style={{ color: "#64748b", fontSize: 22 }} />
//                             <h5 className="mb-0 fw-bold" style={{ color: "#172126" }}>
//                                 Revenue
//                             </h5>
//                         </div>
//                         {viewMode === "list" && !loading && !loadingOutlets && (
//                             <p className="mb-0" style={{ fontSize: 11.5, color: "#94a3b8", fontWeight: 700, marginTop: 3 }}>
//                                 {visibleTableColumns.length} of {displayColumns.length} columns shown
//                                 {displayColumns.length > 5 ? " · scroll horizontally for more" : ""}
//                             </p>
//                         )}
//                     </div>

//                     <div className="d-flex align-items-center gap-2">
//                         <Button
//                             className={`reelo-tab-btn ${viewMode === "list" ? "active" : ""}`}
//                             onClick={() => setViewMode("list")}
//                             style={{ borderRadius: "12px 0 0 12px" }}
//                         >
//                             <i className="bi bi-list-ul me-2" />
//                             List
//                         </Button>
//                         <Button
//                             className={`reelo-tab-btn ${viewMode === "graph" ? "active" : ""}`}
//                             onClick={() => setViewMode("graph")}
//                             style={{ borderRadius: viewMode === "list" ? 0 : "0 12px 12px 0" }}
//                         >
//                             <i className="bi bi-bar-chart-fill me-2" />
//                             Graph
//                         </Button>

//                         {viewMode === "list" && (
//                             <div className="reelo-col-menu-wrap" ref={columnMenuRef}>
//                                 <Button
//                                     className="reelo-tab-btn"
//                                     onClick={() => setShowColumnMenu((prev) => !prev)}
//                                     style={{ borderRadius: "0 12px 12px 0" }}
//                                     aria-label="Customize columns"
//                                     aria-expanded={showColumnMenu}
//                                 >
//                                     <i className="bi bi-sliders me-2" />
//                                     Columns
//                                     {hiddenColumnCount > 0 && (
//                                         <span
//                                             style={{
//                                                 marginLeft: 6,
//                                                 background: "#0ea5a4",
//                                                 color: "#fff",
//                                                 borderRadius: 999,
//                                                 fontSize: 10,
//                                                 fontWeight: 900,
//                                                 padding: "1px 6px",
//                                             }}
//                                         >
//                                             -{hiddenColumnCount}
//                                         </span>
//                                     )}
//                                 </Button>

//                                 {showColumnMenu && (
//                                     <div className="reelo-col-menu">
//                                         <div className="reelo-col-menu-title">Visible Columns</div>
//                                         {displayColumns.map((col) => {
//                                             const isOutlet = col.key === "outletName";
//                                             const isChecked = isOutlet || columnVisibility[col.key] !== false;

//                                             return (
//                                                 <label
//                                                     key={col.key}
//                                                     className={`reelo-col-menu-item${isOutlet ? " disabled" : ""}`}
//                                                 >
//                                                     <input
//                                                         type="checkbox"
//                                                         checked={isChecked}
//                                                         disabled={isOutlet}
//                                                         onChange={() => !isOutlet && toggleColumnVisibility(col.key)}
//                                                     />
//                                                     {col.label}
//                                                 </label>
//                                             );
//                                         })}
//                                     </div>
//                                 )}
//                             </div>
//                         )}
//                     </div>
//                 </div>

//                 {viewMode === "graph" && (
//                     <>
//                         <div className="d-flex gap-2 flex-wrap px-4 pb-3">
//                             <Form.Select
//                                 value={filterType}
//                                 onChange={(e) => setFilterType(e.target.value)}
//                                 style={{ width: 170 }}
//                                 className="reelo-select"
//                             >
//                                 {FILTER_OPTIONS.map((opt) => (
//                                     <option key={opt.value} value={opt.value}>
//                                         {opt.label}
//                                     </option>
//                                 ))}
//                             </Form.Select>

//                             <Form.Select
//                                 value={sortType}
//                                 onChange={(e) => setSortType(e.target.value)}
//                                 style={{ width: 185 }}
//                                 className="reelo-select"
//                             >
//                                 {SORT_OPTIONS.map((opt) => (
//                                     <option key={opt.value} value={opt.value}>
//                                         {opt.label}
//                                     </option>
//                                 ))}
//                             </Form.Select>
//                         </div>

//                         <div style={{ padding: "0 18px 24px" }}>
//                             {loading || loadingOutlets ? (
//                                 <div className="d-flex justify-content-center align-items-center" style={{ height: 420 }}>
//                                     <Spinner animation="border" style={{ color: "#0ea5a4" }} />
//                                 </div>
//                             ) : chartData.length === 0 ? (
//                                 <div className="d-flex justify-content-center align-items-center text-muted" style={{ height: 360 }}>
//                                     No data available
//                                 </div>
//                             ) : (
//                                 <ResponsiveContainer width="100%" height={460}>
//                                     <BarChart data={chartData} barSize={54} margin={{ top: 30, right: 28, left: 4, bottom: 20 }}>
//                                         <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#eef2f7" />
//                                         <XAxis
//                                             dataKey="name"
//                                             tick={{ fontSize: 11, fill: "#6b7280", fontWeight: 700 }}
//                                             axisLine={false}
//                                             tickLine={false}
//                                             angle={-16}
//                                             textAnchor="end"
//                                             interval={0}
//                                         />
//                                         <YAxis
//                                             tick={{ fontSize: 11, fill: "#6b7280", fontWeight: 700 }}
//                                             axisLine={false}
//                                             tickLine={false}
//                                             tickFormatter={(v) =>
//                                                 isAmount
//                                                     ? v >= 1000
//                                                         ? `₹${(v / 1000).toFixed(1)}K`
//                                                         : `₹${v}`
//                                                     : v.toLocaleString("en-IN")
//                                             }
//                                         />
//                                         <Tooltip content={<CustomTooltip />} />
//                                         <Legend
//                                             verticalAlign="bottom"
//                                             wrapperStyle={{ paddingTop: 28, fontWeight: 700 }}
//                                             formatter={() => selectedFilterLabel}
//                                         />
//                                         <Bar dataKey="value" fill="#4d83ee" radius={[7, 7, 0, 0]} animationDuration={800} />
//                                     </BarChart>
//                                 </ResponsiveContainer>
//                             )}
//                         </div>
//                     </>
//                 )}

//                 {viewMode === "list" && (
//                     <div className="reelo-table-outer" style={{ padding: "0 18px 18px" }}>
//                         {loading || loadingOutlets ? (
//                             <div className="d-flex justify-content-center align-items-center" style={{ height: 360 }}>
//                                 <Spinner animation="border" style={{ color: "#0ea5a4" }} />
//                             </div>
//                         ) : (
//                             <>
//                                 <div
//                                     ref={tableWrapRef}
//                                     className={`reelo-table-wrap${tableScrolledLeft ? " is-scrolled-left" : ""}`}
//                                     onScroll={handleTableScroll}
//                                     style={{
//                                         overflowX: "auto",
//                                         overflowY: "auto",
//                                         maxHeight: TABLE_BODY_MAX_HEIGHT,
//                                         borderRadius: 12,
//                                     }}
//                                 >
//                                     <table
//                                         className="w-100"
//                                         style={{
//                                             borderCollapse: "separate",
//                                             borderSpacing: "0 8px",
//                                             fontSize: 13,
//                                             minWidth: tableMinWidth,
//                                         }}
//                                     >
//                                         <colgroup>
//                                             {visibleTableColumns.map((col) => (
//                                                 <col key={col.key} style={{ width: getColumnWidth(col) }} />
//                                             ))}
//                                         </colgroup>

//                                         <thead>
//                                             <tr>
//                                                 {visibleTableColumns.map((col, colIndex) => (
//                                                     <th
//                                                         key={col.key}
//                                                         onClick={() => col.sortable && handleTableSort(col.key)}
//                                                         className={`reelo-thead-cell${colIndex === 0 ? " reelo-sticky-col" : ""}`}
//                                                         style={{
//                                                             padding: "12px 16px",
//                                                             fontSize: 11,
//                                                             fontWeight: 900,
//                                                             textTransform: "uppercase",
//                                                             letterSpacing: ".5px",
//                                                             color: "#748588",
//                                                             textAlign:
//                                                                 col.type === "amount" || col.type === "combo"
//                                                                     ? "right"
//                                                                     : col.type === "count"
//                                                                         ? "center"
//                                                                         : "left",
//                                                             whiteSpace: "nowrap",
//                                                             cursor: col.sortable ? "pointer" : "default",
//                                                             borderBottom: "1px solid #edf3f5",
//                                                         }}
//                                                     >
//                                                         <span
//                                                             style={{
//                                                                 display: "flex",
//                                                                 alignItems: "center",
//                                                                 gap: 6,
//                                                                 justifyContent:
//                                                                     col.type === "amount" || col.type === "combo"
//                                                                         ? "flex-end"
//                                                                         : col.type === "count"
//                                                                             ? "center"
//                                                                             : "flex-start",
//                                                             }}
//                                                         >
//                                                             {col.label}
//                                                             {col.sortable && (
//                                                                 <span style={{ color: sortConfig.key === col.key ? "#0ea5a4" : "#cbd5e1", fontSize: 12 }}>
//                                                                     {sortConfig.key === col.key
//                                                                         ? sortConfig.direction === "asc"
//                                                                             ? "↑"
//                                                                             : "↓"
//                                                                         : "↕"}
//                                                                 </span>
//                                                             )}
//                                                         </span>
//                                                     </th>
//                                                 ))}
//                                             </tr>
//                                         </thead>

//                                         <tbody>
//                                             <tr
//                                                 style={{
//                                                     background: "#f0f9f9",
//                                                     boxShadow: "inset 0 0 0 1px #d7ecec",
//                                                 }}
//                                             >
//                                                 <td
//                                                     className="reelo-sticky-col"
//                                                     style={{
//                                                         padding: "16px",
//                                                         fontWeight: 900,
//                                                         color: "#0f172a",
//                                                         fontSize: 12,
//                                                         textTransform: "uppercase",
//                                                         letterSpacing: ".4px",
//                                                         whiteSpace: "nowrap",
//                                                     }}
//                                                 >
//                                                     Total (All Outlets)
//                                                 </td>

//                                                 {visibleTableColumns.slice(1).map((col) => (
//                                                     <td
//                                                         key={col.key}
//                                                         style={{
//                                                             padding: "16px",
//                                                             textAlign:
//                                                                 col.type === "amount" || col.type === "combo"
//                                                                     ? "right"
//                                                                     : col.type === "count"
//                                                                         ? "center"
//                                                                         : "left",
//                                                             color:
//                                                                 col.key === "cancelledOrders" || col.key === "totalCancelledOrderAmount"
//                                                                     ? "#dc2626"
//                                                                     : col.key === "complimentaryOrders"
//                                                                         ? "#7c3aed"
//                                                                         : "#0f172a",
//                                                             fontWeight: 900,
//                                                             whiteSpace: "nowrap",
//                                                         }}
//                                                     >
//                                                         {col.type === "combo" ? renderComboCell(col, null) : formatTotalCell(col)}
//                                                     </td>
//                                                 ))}
//                                             </tr>

//                                             {sortedData?.length === 0 ? (
//                                                 <tr>
//                                                     <td
//                                                         colSpan={visibleTableColumns?.length}
//                                                         style={{
//                                                             padding: "44px 16px",
//                                                             textAlign: "center",
//                                                             color: "#94a3b8",
//                                                             fontWeight: 700,
//                                                         }}
//                                                     >
//                                                         No outlet data available
//                                                     </td>
//                                                 </tr>
//                                             ) : (
//                                                 sortedData.map((outlet, idx) => (
//                                                     <tr
//                                                         key={outlet?._id || idx}
//                                                         className="reelo-row"
//                                                         style={{
//                                                             background: "#fff",
//                                                             boxShadow: "inset 0 0 0 1px #edf3f5",
//                                                             cursor: "pointer",
//                                                             transition: "background .15s ease",
//                                                         }}
//                                                     >
//                                                         <td
//                                                             className="reelo-sticky-col"
//                                                             onClick={() =>
//                                                                 handleViewModal(
//                                                                     {
//                                                                         isNumeric: false,
//                                                                         key: "outletName",
//                                                                         label: "Outlet Name",
//                                                                         sortable: true,
//                                                                         type: "text",
//                                                                     },
//                                                                     outlet
//                                                                 )
//                                                             }
//                                                             style={{
//                                                                 padding: "15px 16px",
//                                                                 color: "#0f766e",
//                                                                 fontWeight: 800,
//                                                                 whiteSpace: "nowrap",
//                                                                 cursor: "pointer",
//                                                             }}
//                                                         >
//                                                             <span
//                                                                 style={{
//                                                                     width: 28,
//                                                                     height: 28,
//                                                                     borderRadius: 10,
//                                                                     background: "#EAF7F8",
//                                                                     color: "#0ea5a4",
//                                                                     display: "inline-grid",
//                                                                     placeItems: "center",
//                                                                     marginRight: 10,
//                                                                 }}
//                                                             >
//                                                                 <i className="bi bi-shop" />
//                                                             </span>
//                                                             {outlet?.outletName || "—"}
//                                                             <span style={{ color: "#94a3b8", marginLeft: 8 }}>›</span>
//                                                         </td>

//                                                         {visibleTableColumns.slice(1).map((col) => (
//                                                             <td
//                                                                 key={col.key}
//                                                                 onClick={() => handleViewModal(col, outlet)}
//                                                                 style={{
//                                                                     padding: "15px 16px",
//                                                                     textAlign:
//                                                                         col.type === "amount" || col.type === "combo"
//                                                                             ? "right"
//                                                                             : col.type === "count"
//                                                                                 ? "center"
//                                                                                 : "left",
//                                                                     color:
//                                                                         col.key === "cancelledOrders" || col.key === "totalCancelledOrderAmount"
//                                                                             ? "#dc2626"
//                                                                             : col.key === "complimentaryOrders"
//                                                                                 ? "#7c3aed"
//                                                                                 : "#334155",
//                                                                     fontWeight: col.type === "amount" ? 800 : 700,
//                                                                     whiteSpace: "nowrap",
//                                                                 }}
//                                                             >
//                                                                 {col.type === "combo" ? renderComboCell(col, outlet) : formatCell(col, outlet)}
//                                                             </td>
//                                                         ))}
//                                                     </tr>
//                                                 ))
//                                             )}
//                                         </tbody>
//                                     </table>
//                                 </div>

//                                 {/* Edge gradients: hint that more columns exist off-screen. */}
//                                 <div className={`reelo-scroll-edge edge-left${tableScrolledLeft ? " visible" : ""}`} />
//                                 <div className={`reelo-scroll-edge edge-right${canScrollRight ? " visible" : ""}`} />

//                                 {/* Arrow controls: small, unobtrusive, only interactive at the boundary that matters. */}
//                                 <button
//                                     type="button"
//                                     className={`reelo-scroll-btn btn-left${tableScrolledLeft ? " visible" : ""}`}
//                                     onClick={() => scrollTableBy(-ARROW_SCROLL_DELTA)}
//                                     aria-label="Scroll table left"
//                                     title="Scroll left"
//                                 >
//                                     <i className="bi bi-chevron-left" />
//                                 </button>
//                                 <button
//                                     type="button"
//                                     className={`reelo-scroll-btn btn-right${canScrollRight ? " visible" : ""}`}
//                                     onClick={() => scrollTableBy(ARROW_SCROLL_DELTA)}
//                                     aria-label="Scroll table right"
//                                     title="Scroll right"
//                                 >
//                                     <i className="bi bi-chevron-right" />
//                                 </button>

//                                 <p style={{ fontSize: 12, color: "#94a3b8", margin: "8px 0 0 4px", fontWeight: 600 }}>
//                                     Click any row to view outlet details
//                                 </p>
//                             </>
//                         )}
//                     </div>
//                 )}
//             </div>

//             {openViewModal && (
//                 <OutletDetailsModal
//                     isOpen={openViewModal}
//                     onClose={() => {
//                         setOpenViewModal(false);
//                         setViewModalData(null);
//                     }}
//                     outletName={selectedOutletName}
//                     data={viewModalData}
//                     loading={viewModalLoading}
//                 />
//             )} 
//         </Container>
//     );
// };

// OutletRevenueKpi.propTypes = {
//     outletFilter: PropTypes.string.isRequired,
//     loadingOutlets: PropTypes.bool.isRequired,
// };

// export default OutletRevenueKpi;


// New Code With Less Number of Columns
// New Code
import React, { useState, useEffect, useCallback, useMemo, useRef } from "react";
import ReactDOM from "react-dom";
import { Container, Form, Spinner, Button } from "react-bootstrap";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
    Legend,
} from "recharts";
import PropTypes from "prop-types";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import OutletDetailsModal from "./OutletDetailsModal";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../api/axios";

const FILTER_OPTIONS = [
    { label: "Total Sales", value: "totalSales", dataKey: "totalRevenue" },
    { label: "Net Sales", value: "netSales", dataKey: "netSaleRevenue" },
    { label: "Orders", value: "orders", dataKey: "totalOrders" },
];

const SORT_OPTIONS = [
    { label: "Top 10 Outlets", value: "-1" },
    { label: "Bottom 10 Outlets", value: "1" },
];

const DATE_FILTER_OPTIONS = [
    { label: "Today", value: "today" },
    { label: "Yesterday", value: "yesterday" },
    { label: "Last 7 Days", value: "last7days" },
    { label: "Last 30 Days", value: "last30days" },
    { label: "This Month", value: "thisMonth" },
    { label: "Last Month", value: "lastMonth" },
    { label: "Custom Range", value: "custom" },
];

// Height of the scrollable outlet-list body. Responsive: never taller than
// 55% of the viewport, capped at 560px so it still behaves on huge monitors.
const TABLE_BODY_MAX_HEIGHT = "min(55vh, 560px)";

// How far the horizontal arrow controls scroll the table per click.
const ARROW_SCROLL_DELTA = 360;

// Columns that are always shown, in order. This drives calculations
// (calculatedTotals sums every one of these) — it is NOT the same as what
// gets rendered; see `displayColumns` below for the merged Quick
// Order/Quick Serve presentation.
const BASE_TABLE_COLUMNS = [
    { key: "outletName", label: "Outlet Name", sortable: true, isNumeric: false, type: "text" },
    {
        key: "totalOrders",
        label: "Order(s)",
        sortable: true,
        isNumeric: true,
        type: "count",
        helperText: "Orders Count Does not included zomato swiggy order count",
    },
    {
        key: "grossSales",
        label: "Gross",
        sortable: true,
        isNumeric: true,
        type: "amount",
        helperText: "Includes Zomato Swiggy Sales",
    },
    {
        key: "netSalesInclThirdParty",
        label: "Net",
        sortable: true,
        isNumeric: true,
        type: "amount",
        helperText: "Sales Excluding Tax",
    },
    { key: "offlineSales", label: "Offline", sortable: true, isNumeric: true, type: "amount" },
    { key: "onlineSales", label: "Online", sortable: true, isNumeric: true, type: "amount" },
    { key: "thirdPartySales", label: "Food Apps", sortable: true, isNumeric: true, type: "amount" },
    { key: "cancelledOrders", label: "Canc. Orders", sortable: true, isNumeric: true, type: "count" },
    { key: "totalCancelledOrderAmount", label: "Canc. Amount", sortable: true, isNumeric: true, type: "amount" },
    { key: "complimentaryOrders", label: "Compl. Orders", sortable: true, isNumeric: true, type: "count" },
    { key: "totalRevenue", label: "Total Sales", sortable: true, isNumeric: true, type: "amount" },
    { key: "netSaleRevenue", label: "Net Sales", sortable: true, isNumeric: true, type: "amount" },
    { key: "appOrders", label: "App Orders", sortable: true, isNumeric: true, type: "count" },
    { key: "appNetSaleRevenue", label: "App Net Revenue", sortable: true, isNumeric: true, type: "amount" },
    { key: "kioskOrders", label: "Kiosk Orders", sortable: true, isNumeric: true, type: "count" },
    { key: "kioskNetSale", label: "Kiosk Net Sale", sortable: true, isNumeric: true, type: "amount" },
    { key: "totalQuickOrderNetSaleCount", label: "Qr Web Orders", sortable: true, isNumeric: true, type: "count" },
    { key: "totalQuickOrderNetSaleRevenue", label: "Qr Web Revenue", sortable: true, isNumeric: true, type: "amount" },
    { key: "totalQuickServeNetSaleCount", label: "Walk In Orders", sortable: true, isNumeric: true, type: "count" },
    { key: "totalQuickServeNetSaleRevenue", label: "Walk In Revenue", sortable: true, isNumeric: true, type: "amount" },
];

// Columns visible by default when the table first loads. Everything else
// still exists and can be turned on from the Columns menu.
const DEFAULT_VISIBLE_COLUMN_KEYS = new Set([
    "outletName",
    "totalOrders",
    "grossSales",
    "netSalesInclThirdParty",
    "offlineSales",
    "onlineSales",
    "thirdPartySales",
    "cancelledCombo",
]);

// Columns that only appear when the current response actually contains that
// platform's data (i.e. at least one outlet took a Zomato/Swiggy order).
const OPTIONAL_TABLE_COLUMNS = [
    {
        key: "zomatoOrders",
        label: "Zomato Orders",
        sortable: true,
        isNumeric: true,
        type: "count",
        presenceKeys: ["zomatoOrders", "zomatoNetSaleRevenue", "zomatoRevenue"],
    },
    {
        key: "zomatoNetSaleRevenue",
        label: "Zomato Revenue",
        sortable: true,
        isNumeric: true,
        type: "amount",
        fallbackKey: "zomatoRevenue",
        presenceKeys: ["zomatoOrders", "zomatoNetSaleRevenue", "zomatoRevenue"],
        platformName: "ZOMATO",
    },
    {
        key: "swiggyOrders",
        label: "Swiggy Orders",
        sortable: true,
        isNumeric: true,
        type: "count",
        presenceKeys: ["swiggyOrders", "swiggyNetSaleRevenue", "swiggyRevenue"],
    },
    {
        key: "swiggyNetSaleRevenue",
        label: "Swiggy Revenue",
        sortable: true,
        isNumeric: true,
        type: "amount",
        fallbackKey: "swiggyRevenue",
        presenceKeys: ["swiggyOrders", "swiggyNetSaleRevenue", "swiggyRevenue"],
        platformName: "SWIGGY",
    },
];

// Pairs of (count, revenue) columns that should render as ONE combined
// column: revenue on top (the number that matters most), order count
// underneath it as context.
const COMBO_COLUMN_DEFS = [
    {
        key: "cancelledCombo",
        label: "Cancelled",
        type: "combo",
        sortable: true,
        countKey: "cancelledOrders",
        amountKey: "totalCancelledOrderAmount",
        replaces: ["cancelledOrders", "totalCancelledOrderAmount"],
        insertAfterKey: "totalCancelledOrderAmount",
    },
    {
        key: "appCombo",
        label: "App",
        type: "combo",
        sortable: true,
        countKey: "appOrders",
        amountKey: "appNetSaleRevenue",
        replaces: ["appOrders", "appNetSaleRevenue"],
        insertAfterKey: "appNetSaleRevenue",
    },
    {
        key: "kioskCombo",
        label: "Kiosk",
        type: "combo",
        sortable: true,
        countKey: "kioskOrders",
        amountKey: "kioskNetSale",
        replaces: ["kioskOrders", "kioskNetSale"],
        insertAfterKey: "kioskNetSale",
    },
    {
        key: "quickOrderCombo",
        label: "Qr Web Orders",
        type: "combo",
        sortable: true,
        countKey: "totalQuickOrderNetSaleCount",
        amountKey: "totalQuickOrderNetSaleRevenue",
        replaces: ["totalQuickOrderNetSaleCount", "totalQuickOrderNetSaleRevenue"],
        insertAfterKey: "totalQuickOrderNetSaleRevenue",
    },
    {
        key: "quickServeCombo",
        label: "Walk In",
        type: "combo",
        sortable: true,
        countKey: "totalQuickServeNetSaleCount",
        amountKey: "totalQuickServeNetSaleRevenue",
        replaces: ["totalQuickServeNetSaleCount", "totalQuickServeNetSaleRevenue"],
        insertAfterKey: "totalQuickServeNetSaleRevenue",
    },
];

// When a combo column header is clicked, sort by its revenue field — that's
// the number that actually differentiates outlets.
const COMBO_SORT_KEY_MAP = COMBO_COLUMN_DEFS.reduce((acc, combo) => {
    acc[combo.key] = combo.amountKey;
    return acc;
}, {});

const COMBO_KEYS_TO_HIDE = new Set(COMBO_COLUMN_DEFS.flatMap((combo) => combo.replaces));
const COMBO_BY_INSERT_KEY = COMBO_COLUMN_DEFS.reduce((acc, combo) => {
    acc[combo.insertAfterKey] = combo;
    return acc;
}, {});

const hasAnyValue = (source, keys) =>
    keys.some((k) => source?.[k] !== undefined && source?.[k] !== null);

const getPlatformSalesFromArray = (arr, platformName, field = "totalSales") => {
    const entry = (arr || []).find((p) => (p?.platform || "").toUpperCase() === platformName);
    return Number(entry?.[field]) || 0;
};

const getZomatoRevenue = (source, field = "totalSales") =>
    getPlatformSalesFromArray(source?.thirdPartySalesByPlatform, "ZOMATO", field) ||
    Number(source?.zomatoNetSaleRevenue ?? source?.zomatoRevenue) ||
    0;

const getSwiggyRevenue = (source, field = "totalSales") =>
    getPlatformSalesFromArray(source?.thirdPartySalesByPlatform, "SWIGGY", field) ||
    Number(source?.swiggyNetSaleRevenue ?? source?.swiggyRevenue) ||
    0;

const getPlatformTotal = (thirdPartySalesByPlatform, platformName, field = "totalSales") => {
    const entry = (thirdPartySalesByPlatform || []).find(
        (p) => (p?.platform || "").toUpperCase() === platformName
    );
    return Number(entry?.[field]) || 0;
};

const formatCardValue = (val, isCount = false) => {
    if (val === undefined || val === null) return isCount ? "0" : "₹0.00";
    const num = Number(val);
    if (isCount) return num.toLocaleString("en-IN");
    return `₹${num.toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    })}`;
};

const formatAmountValue = (val) =>
    `₹${(Number(val) || 0).toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    })}`;

const formatCountValue = (val) => {
    const num = Number(val) || 0;
    return Number.isInteger(num) ? num.toLocaleString("en-IN") : num.toFixed(0);
};

const getDefaultStartDate = () => {
    const d = new Date();
    d.setDate(d.getDate() - 91);
    return d;
};

const toLocalDateStr = (d) => {
    const pad = (n) => String(n).padStart(2, "0");
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

const inclusiveDayCount = (start, end) => {
    const diff = Math.floor((end - start) / (1000 * 60 * 60 * 24));
    return diff + 1;
};

const getColumnWidth = (col) => {
    if (col.key === "outletName") return 252;
    if (col.type === "combo") return 176;
    if (col.type === "amount") return col.label.length > 20 ? 224 : 152;
    if (col.type === "count") return 132;
    return 160;
};

const SUMMARY_CARDS = [
    {
        key: "totalRevenue",
        label: "Gross Sales (Exc Zo/Sw)",
        icon: "bi-currency-rupee",
        accent: "#f97316",
        bg: "#FFF5EC",
        shape: "coin",
    },
    {
        key: "netSaleRevenue",
        label: "Net Sales (Exc Zo/Sw)",
        icon: "bi-receipt-cutoff",
        accent: "#10b981",
        bg: "#ECFFF7",
        shape: "bag",
    },
    {
        key: "appNetSaleRevenue",
        label: "App Sales",
        icon: "bi-phone",
        accent: "#6d28d9",
        bg: "#F3F0FF",
        shape: "gift",
    },
];

const OUTLET_SALES_CARD = {
    label: "Outlet Sales",
    accent: "#0f172a",
    bg: " rgb(238, 247, 255)",
};

const OUTLET_SALES_ITEMS = [
    {
        key: "kioskNetSale",
        countKey: "kioskOrders",
        label: "Kiosk",
        accent: "#2563eb",
    },
    {
        key: "totalQuickOrderNetSaleRevenue",
        countKey: "totalQuickOrderNetSaleCount",
        label: "Qr Web Orders",
        accent: "#d97706",
    },
    {
        key: "totalQuickServeNetSaleRevenue",
        countKey: "totalQuickServeNetSaleCount",
        label: "Walk In",
        accent: "#0f766e",
    },
];

const ReeloShape = ({ type, accent }) => {
    const common = {
        position: "absolute",
        right: -12,
        bottom: -20,
        width: 118,
        height: 118,
        opacity: 0.92,
        pointerEvents: "none",
    };

    if (type === "coin") {
        return (
            <div style={common}>
                <div
                    style={{
                        width: 96,
                        height: 96,
                        borderRadius: "50%",
                        background: "linear-gradient(135deg,#ffd27a,#f59e0b)",
                        boxShadow: "inset -12px -12px 18px rgba(140,74,0,.22)",
                        display: "grid",
                        placeItems: "center",
                        transform: "rotate(-18deg)",
                    }}
                >
                    <span style={{ fontSize: 42, fontWeight: 900, color: "#fff7df" }}>₹</span>
                </div>
            </div>
        );
    }

    if (type === "bag") {
        return (
            <div style={common}>
                <div
                    style={{
                        width: 86,
                        height: 76,
                        borderRadius: "12px 12px 22px 22px",
                        background: "linear-gradient(135deg,#ff8a00,#ef4444)",
                        marginTop: 28,
                        transform: "rotate(2deg)",
                    }}
                />
                <div
                    style={{
                        position: "absolute",
                        top: 18,
                        left: 26,
                        width: 42,
                        height: 36,
                        border: "7px solid rgba(255,255,255,.75)",
                        borderBottom: 0,
                        borderRadius: "24px 24px 0 0",
                    }}
                />
            </div>
        );
    }

    if (type === "gift") {
        return (
            <div style={common}>
                <div
                    style={{
                        width: 92,
                        height: 72,
                        marginTop: 26,
                        borderRadius: 14,
                        background: "linear-gradient(135deg,#7c3aed,#ef4444)",
                        transform: "rotate(-10deg)",
                    }}
                />
                <div
                    style={{
                        position: "absolute",
                        top: 25,
                        left: 42,
                        width: 13,
                        height: 75,
                        background: "rgba(255,220,120,.9)",
                        transform: "rotate(-10deg)",
                    }}
                />
                <div
                    style={{
                        position: "absolute",
                        top: 52,
                        left: 4,
                        width: 92,
                        height: 12,
                        background: "rgba(255,220,120,.9)",
                        transform: "rotate(-10deg)",
                    }}
                />
            </div>
        );
    }

    return (
        <div style={common}>
            <div
                style={{
                    width: 62,
                    height: 62,
                    borderRadius: "50%",
                    background: "linear-gradient(135deg,#ffd0c2,#9b5b44)",
                    marginLeft: 34,
                }}
            />
            <div
                style={{
                    width: 96,
                    height: 82,
                    borderRadius: "48px 48px 18px 18px",
                    background: `linear-gradient(135deg,${accent},#f97316)`,
                    marginTop: -4,
                    marginLeft: 12,
                }}
            />
        </div>
    );
};

// ---- Custom-styled tooltip for header helper icons ----
// Rendered through a portal straight to document.body and positioned with
// `position: fixed` from the icon's real screen coordinates. This is
// deliberate: the table header sits inside a horizontally/vertically
// scrolling container (.reelo-table-wrap, overflow: auto), which clips any
// absolutely-positioned descendant no matter what z-index or overflow rules
// are set on the header cell itself. Escaping to a portal also sidesteps
// the header's `text-transform: uppercase`, which would otherwise be
// inherited by the tooltip text since CSS inheritance follows the DOM tree,
// not the React component tree.
const InfoTooltip = ({ text }) => {
    const [show, setShow] = useState(false);
    const [coords, setCoords] = useState({ top: 0, left: 0 });
    const iconRef = useRef(null);

    const updatePosition = useCallback(() => {
        const rect = iconRef.current?.getBoundingClientRect();
        if (!rect) return;
        setCoords({
            top: rect.top,
            left: rect.left + rect.width / 2,
        });
    }, []);

    const handleEnter = () => {
        updatePosition();
        setShow(true);
    };

    const handleLeave = () => setShow(false);

    // Keep the tooltip glued to the icon if the table (or the page) scrolls
    // or resizes while it's open, rather than letting it drift or go stale.
    useEffect(() => {
        if (!show) return undefined;
        const handle = () => updatePosition();
        window.addEventListener("scroll", handle, true);
        window.addEventListener("resize", handle);
        return () => {
            window.removeEventListener("scroll", handle, true);
            window.removeEventListener("resize", handle);
        };
    }, [show, updatePosition]);

    return (
        <>
            <i
                ref={iconRef}
                className="bi bi-info-circle"
                style={{ fontSize: 11, color: "#94a3b8", cursor: "pointer" }}
                onMouseEnter={handleEnter}
                onMouseLeave={handleLeave}
                onClick={(e) => e.stopPropagation()}
                onMouseDown={(e) => e.stopPropagation()}
            />
            {show &&
                ReactDOM.createPortal(
                    <div
                        role="tooltip"
                        style={{
                            position: "fixed",
                            top: coords.top - 8,
                            left: coords.left,
                            transform: "translate(-50%, -100%)",
                            background: "#101820",
                            color: "#fff",
                            fontSize: 11,
                            fontWeight: 600,
                            textTransform: "none",
                            lineHeight: 1.4,
                            padding: "7px 11px",
                            borderRadius: 8,
                            whiteSpace: "normal",
                            maxWidth: 220,
                            width: "max-content",
                            textAlign: "left",
                            boxShadow: "0 12px 26px rgba(15,23,42,.28)",
                            zIndex: 2000,
                            pointerEvents: "none",
                        }}
                    >
                        {text}
                        <div
                            style={{
                                position: "absolute",
                                top: "100%",
                                left: "50%",
                                transform: "translateX(-50%)",
                                width: 0,
                                height: 0,
                                borderLeft: "5px solid transparent",
                                borderRight: "5px solid transparent",
                                borderTop: "5px solid #101820",
                            }}
                        />
                    </div>,
                    document.body
                )}
        </>
    );
};

const OutletRevenueKpi = ({ outletFilter, loadingOutlets }) => {
    const token = localStorage.getItem("authToken");
    const navigate = useNavigate();

    const [viewMode, setViewMode] = useState("list");
    const [filterType, setFilterType] = useState("totalSales");
    const [sortType, setSortType] = useState("-1");
    const [dateFilter, setDateFilter] = useState("today");
    const [outletData, setOutletData] = useState([]);
    const [totalsData, setTotalsData] = useState(null);
    const [thirdPartySalesByPlatform, setThirdPartySalesByPlatform] = useState([]);
    const [showNetSalesIncl, setShowNetSalesIncl] = useState(false);
    const [showTotalSalesIncl, setShowTotalSalesIncl] = useState(false);
    const [loading, setLoading] = useState(true);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

    const [customStartDate, setCustomStartDate] = useState(getDefaultStartDate);
    const [customEndDate, setCustomEndDate] = useState(() => new Date());
    const [customDateError, setCustomDateError] = useState("");
    const [appliedCustomRange, setAppliedCustomRange] = useState(null);

    const [openViewModal, setOpenViewModal] = useState(false);
    const [viewModalLoading, setViewModalLoading] = useState(false);
    const [viewModalData, setViewModalData] = useState(null);
    const [selectedOutletName, setSelectedOutletName] = useState("");

    const [tableScrolledLeft, setTableScrolledLeft] = useState(false);
    const [canScrollRight, setCanScrollRight] = useState(false);
    const [columnVisibility, setColumnVisibility] = useState({});
    const [showColumnMenu, setShowColumnMenu] = useState(false);

    const tableWrapRef = useRef(null);
    const columnMenuRef = useRef(null);
    const scrollRafRef = useRef(null);

    const currentFilterOption = FILTER_OPTIONS.find((f) => f.value === filterType) || FILTER_OPTIONS[0];
    const currentDataKey = currentFilterOption.dataKey;
    const selectedFilterLabel = currentFilterOption.label;
    const isAmount = currentDataKey !== "totalOrders";

    const tableColumns = useMemo(() => {
        const visibleOptional = OPTIONAL_TABLE_COLUMNS.filter(
            (col) =>
                outletData.some(
                    (o) =>
                        hasAnyValue(o, col.presenceKeys) ||
                        (col.platformName && getPlatformSalesFromArray(o?.thirdPartySalesByPlatform, col.platformName) > 0)
                ) || hasAnyValue(totalsData, col.presenceKeys)
        );
        return [...BASE_TABLE_COLUMNS, ...visibleOptional];
    }, [outletData, totalsData]);

    const displayColumns = useMemo(() => {
        const result = [];
        tableColumns.forEach((col) => {
            if (COMBO_KEYS_TO_HIDE.has(col.key)) {
                const combo = COMBO_BY_INSERT_KEY[col.key];
                if (combo) result.push(combo);
                return;
            }
            result.push(col);
        });
        return result;
    }, [tableColumns]);

    useEffect(() => {
        setColumnVisibility((prev) => {
            let changed = false;
            const next = { ...prev };
            displayColumns.forEach((col) => {
                if (!(col.key in next)) {
                    next[col.key] = DEFAULT_VISIBLE_COLUMN_KEYS.has(col.key);
                    changed = true;
                }
            });
            return changed ? next : prev;
        });
    }, [displayColumns]);

    const visibleTableColumns = useMemo(
        () => displayColumns.filter((col) => col.key === "outletName" || columnVisibility[col.key] !== false),
        [displayColumns, columnVisibility]
    );

    const tableMinWidth = useMemo(
        () => visibleTableColumns.reduce((sum, col) => sum + getColumnWidth(col), 0),
        [visibleTableColumns]
    );

    const fetchOutletRevenueStats = useCallback(async () => {
        try {
            setLoading(true);

            let url = `dashboard/getAllOutletRevenueStats?filter=${filterType}&sort=${sortType}`;

            if (dateFilter === "custom" && appliedCustomRange) {
                url += `&startDate=${appliedCustomRange.start}&endDate=${appliedCustomRange.end}`;
            } else {
                url += `&dateFilter=${dateFilter}`;
            }

            if (outletFilter && outletFilter !== "all") {
                url += `&outletId=${outletFilter}`;
            }

            const response = await axiosInstance.get(url, {
                headers: { Authorization: `Bearer ${token}` },
            });

            if (response?.data?.status === true) {
                const inner = response?.data?.data?.data;
                setOutletData(inner?.outletSales || []);
                setTotalsData(inner?.totalRevenueOfAllOutlets || null);
                setThirdPartySalesByPlatform(inner?.thirdPartySalesByPlatform || []);
            }
        } catch (error) {
            console.error("Error fetching outlet revenue stats:", error);
        } finally {
            setLoading(false);
        }
    }, [token, filterType, sortType, dateFilter, outletFilter, appliedCustomRange]);

    useEffect(() => {
        fetchOutletRevenueStats();
    }, [fetchOutletRevenueStats]);

    const thirdPartyTotals = useMemo(() => {
        const zomatoSales = getPlatformTotal(thirdPartySalesByPlatform, "ZOMATO", "totalSales");
        const swiggySales = getPlatformTotal(thirdPartySalesByPlatform, "SWIGGY", "totalSales");
        const zomatoPrice = getPlatformTotal(thirdPartySalesByPlatform, "ZOMATO", "totalPrice");
        const swiggyPrice = getPlatformTotal(thirdPartySalesByPlatform, "SWIGGY", "totalPrice");
        return {
            zomato: zomatoSales,
            swiggy: swiggySales,
            combined: zomatoSales + swiggySales,
            salesCombined: zomatoSales + swiggySales,
            priceCombined: zomatoPrice + swiggyPrice,
        };
    }, [thirdPartySalesByPlatform]);

    const processedOutletData = useMemo(
        () =>
            outletData.map((outlet) => ({
                ...outlet,
                netOrders: (Number(outlet.totalOrders) || 0) - (Number(outlet.cancelledOrders) || 0),
                netAppOrders: (Number(outlet.appOrders) || 0) - (Number(outlet.cancelledAppOrders) || 0),
                netKioskOrders: (Number(outlet.kioskOrders) || 0) - (Number(outlet.cancelledKioskOrders) || 0),
                grossSales:
                    (Number(outlet.totalRevenue) || 0) +
                    getZomatoRevenue(outlet) +
                    getSwiggyRevenue(outlet),
                offlineSales:
                    (Number(outlet.totalQuickOrderNetSaleRevenue) || 0) +
                    (Number(outlet.totalQuickServeNetSaleRevenue) || 0),
                netSalesInclThirdParty:
                    (Number(outlet.netSaleRevenue) || 0) +
                    getZomatoRevenue(outlet, "totalPrice") +
                    getSwiggyRevenue(outlet, "totalPrice"),
                onlineSales: (Number(outlet.appNetSaleRevenue) || 0) + (Number(outlet.kioskNetSale) || 0),
                thirdPartySales: getZomatoRevenue(outlet) + getSwiggyRevenue(outlet),
            })),
        [outletData]
    );

    const calculatedTotals = useMemo(() => {
        const acc = processedOutletData.reduce((a, outlet) => {
            tableColumns.forEach((col) => {
                if (col.isNumeric) {
                    const rawVal = col.platformName
                        ? getPlatformSalesFromArray(outlet?.thirdPartySalesByPlatform, col.platformName)
                        : outlet[col.key] ?? (col.fallbackKey ? outlet[col.fallbackKey] : undefined);
                    a[col.key] = (a[col.key] || 0) + (Number(rawVal) || 0);
                }
            });
            return a;
        }, {});
        acc.netOrders = (acc.totalOrders || 0) - (acc.cancelledOrders || 0);
        acc.netSalesInclThirdParty = processedOutletData.reduce(
            (sum, outlet) => sum + (Number(outlet.netSalesInclThirdParty) || 0),
            0
        );
        acc.grossSales = processedOutletData.reduce(
            (sum, outlet) => sum + (Number(outlet.grossSales) || 0),
            0
        );
        acc.offlineSales = processedOutletData.reduce(
            (sum, outlet) => sum + (Number(outlet.offlineSales) || 0),
            0
        );
        return acc;
    }, [processedOutletData, tableColumns]);

    const netSalesInclThirdPartyTotal = useMemo(() => {
        const baseNet = Number(totalsData?.netSaleRevenue ?? calculatedTotals?.netSaleRevenue ?? 0);
        return baseNet + thirdPartyTotals.priceCombined;
    }, [totalsData, calculatedTotals, thirdPartyTotals]);

    const totalSalesInclThirdPartyTotal = useMemo(() => {
        const baseTotal = Number(totalsData?.totalRevenue ?? calculatedTotals?.totalRevenue ?? 0);
        return baseTotal + thirdPartyTotals.salesCombined;
    }, [totalsData, calculatedTotals, thirdPartyTotals]);

    const truncateName = (name, maxLen = 14) =>
        name?.length > maxLen ? `${name.slice(0, maxLen)}...` : name;

    const chartData = useMemo(() => {
        let data = processedOutletData.map((outlet) => ({
            name: truncateName(outlet?.outletName || ""),
            fullName: outlet?.outletName || "",
            value: Number(outlet?.[currentDataKey]) || 0,
        }));

        if (filterType === "orders") {
            data = [...data].sort((a, b) => (sortType === "-1" ? b.value - a.value : a.value - b.value));
        }

        return data;
    }, [processedOutletData, currentDataKey, filterType, sortType]);

    const sortedData = useMemo(
        () =>
            [...processedOutletData].sort((a, b) => {
                if (!sortConfig.key) return 0;

                const effectiveKey = COMBO_SORT_KEY_MAP[sortConfig.key] || sortConfig.key;

                const valA = a?.[effectiveKey] ?? 0;
                const valB = b?.[effectiveKey] ?? 0;

                if (typeof valA === "string") {
                    return sortConfig.direction === "asc"
                        ? valA.localeCompare(valB)
                        : valB.localeCompare(valA);
                }

                return sortConfig.direction === "asc" ? valA - valB : valB - valA;
            }),
        [processedOutletData, sortConfig]
    );

    const handleApplyCustomRange = () => {
        if (!customStartDate || !customEndDate) {
            setCustomDateError("Please select both dates.");
            return;
        }

        const diffDays = inclusiveDayCount(customStartDate, customEndDate);

        if (diffDays > 90) {
            setCustomDateError("Range cannot exceed 90 days.");
            return;
        }

        setCustomDateError("");
        setAppliedCustomRange({
            start: toLocalDateStr(customStartDate),
            end: toLocalDateStr(customEndDate),
        });
    };

    const handleViewModal = (col, outlet) => {
        navigate(`/dashboard/outlet-details/${outlet?._id}`, {
            state: {
                outletName: outlet?.outletName,
                dateFilter,
                customRange: appliedCustomRange,
            },
        });
    };

    const getOutletOrdersDetails = async (outletId, dateF) => {
        try {
            setViewModalLoading(true);
            const headers = { Authorization: `Bearer ${token}` };

            let url = `/dashboard/getRevenueStatThroughSummaryByOutlet?outletId=${outletId}`;

            if (dateF === "custom" && appliedCustomRange) {
                url += `&filterType=custom&startDate=${appliedCustomRange.start}&endDate=${appliedCustomRange.end}`;
            } else {
                url += `&filterType=${dateFilter}`;
            }

            const response = await axiosInstance.get(url, { headers });
            setViewModalData(response?.data?.data);
        } catch (error) {
            console.log("Error in Getting Outlet Order Details :", error);
        } finally {
            setViewModalLoading(false);
        }
    };

    const getNetOrdersTotal = () => {
        const total = totalsData?.totalOrders ?? calculatedTotals?.totalOrders ?? 0;
        const cancelled = totalsData?.cancelledOrders ?? calculatedTotals?.cancelledOrders ?? 0;
        return total - cancelled;
    };

    const handleTableSort = (key) => {
        setSortConfig((prev) => ({
            key,
            direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc",
        }));
    };

    const formatCell = (col, outlet) => {
        let val = outlet?.[col.key];
        if (val === undefined || val === null) {
            val = col.fallbackKey ? outlet?.[col.fallbackKey] : val;
        }

        if (col.platformName) {
            val = getPlatformSalesFromArray(outlet?.thirdPartySalesByPlatform, col.platformName);
        }

        if (col.key === "netOrders") {
            val = (Number(outlet?.totalOrders) || 0) - (Number(outlet?.cancelledOrders) || 0);
        }

        if (!col.isNumeric) return val || "—";

        if (val === undefined || val === null) {
            return col.type === "amount" ? "₹0.00" : "0";
        }

        if (col.type === "amount") {
            return formatAmountValue(val);
        }

        return formatCountValue(val);
    };

    const formatTotalCell = (col) => {
        if (!col.isNumeric) return "—";

        if (col.key === "grossSales") {
            return formatAmountValue(totalSalesInclThirdPartyTotal);
        }

        if (col.key === "offlineSales") {
            const quickOrderTotal =
                totalsData?.totalQuickOrderNetSaleRevenue ?? calculatedTotals?.totalQuickOrderNetSaleRevenue ?? 0;
            const quickServeTotal =
                totalsData?.totalQuickServeNetSaleRevenue ?? calculatedTotals?.totalQuickServeNetSaleRevenue ?? 0;
            return formatAmountValue(Number(quickOrderTotal) + Number(quickServeTotal));
        }

        if (col.key === "netSalesInclThirdParty") {
            const baseNet = Number(totalsData?.netSaleRevenue ?? calculatedTotals?.netSaleRevenue ?? 0);
            const val = baseNet + thirdPartyTotals.priceCombined;
            return formatAmountValue(val);
        }

        let val =
            totalsData?.[col.key] ??
            (col.fallbackKey ? totalsData?.[col.fallbackKey] : undefined) ??
            calculatedTotals?.[col.key];

        if (col.key === "netOrders") {
            const netOrders =
                (totalsData?.totalOrders ?? calculatedTotals?.totalOrders ?? 0) -
                (totalsData?.cancelledOrders ?? calculatedTotals?.cancelledOrders ?? 0);

            return netOrders.toLocaleString("en-IN");
        }

        if (val === undefined || val === null) {
            return col.type === "amount" ? "₹0.00" : "0";
        }

        if (col.type === "amount") {
            return formatAmountValue(val);
        }

        return formatCountValue(val);
    };

    const renderComboCell = (col, source) => {
        const amountVal = source
            ? source?.[col.amountKey]
            : totalsData?.[col.amountKey] ?? calculatedTotals?.[col.amountKey];
        const countVal = source
            ? source?.[col.countKey]
            : totalsData?.[col.countKey] ?? calculatedTotals?.[col.countKey];

        const isCancelled = col.key === "cancelledCombo";

        return (
            <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", lineHeight: 1.3 }}>
                <span style={{ fontWeight: 800, color: isCancelled ? "#dc2626" : undefined }}>
                    {formatAmountValue(amountVal)}
                </span>
                <span style={{ fontSize: 11, fontWeight: 700, color: isCancelled ? "#dc2626" : "#94a3b8" }}>
                    {formatCountValue(countVal)} orders
                </span>
            </div>
        );
    };

    const updateScrollState = useCallback((el) => {
        if (!el) return;
        const { scrollLeft, scrollWidth, clientWidth } = el;
        setTableScrolledLeft(scrollLeft > 2);
        setCanScrollRight(scrollWidth - clientWidth - scrollLeft > 2);
    }, []);

    const handleTableScroll = useCallback(
        (e) => {
            const el = e.currentTarget;
            if (scrollRafRef.current) return;
            scrollRafRef.current = requestAnimationFrame(() => {
                updateScrollState(el);
                scrollRafRef.current = null;
            });
        },
        [updateScrollState]
    );

    useEffect(() => {
        const el = tableWrapRef.current;
        if (!el) return;
        updateScrollState(el);
    }, [visibleTableColumns, sortedData, tableMinWidth, updateScrollState]);

    useEffect(() => {
        return () => {
            if (scrollRafRef.current) cancelAnimationFrame(scrollRafRef.current);
        };
    }, []);

    const scrollTableBy = (delta) => {
        const el = tableWrapRef.current;
        if (!el) return;
        el.scrollBy({ left: delta, behavior: "smooth" });
    };

    useEffect(() => {
        if (!showColumnMenu) return undefined;

        const handleClickOutside = (event) => {
            if (columnMenuRef.current && !columnMenuRef.current.contains(event.target)) {
                setShowColumnMenu(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [showColumnMenu]);

    const toggleColumnVisibility = (key) => {
        setColumnVisibility((prev) => ({ ...prev, [key]: prev[key] === false }));
    };

    const hiddenColumnCount = displayColumns.length - visibleTableColumns.length;

    // ---- Modernized chart tooltip: frosted glass, color dot, label/value split ----
    const CustomTooltip = ({ active, payload }) => {
        if (!active || !payload?.length) return null;

        const val = payload[0]?.value;
        const isCount = !isAmount;

        return (
            <div
                style={{
                    background: "rgba(255, 255, 255, 0.92)",
                    backdropFilter: "blur(10px)",
                    WebkitBackdropFilter: "blur(10px)",
                    border: "1px solid rgba(15, 23, 42, 0.06)",
                    borderRadius: 16,
                    padding: "12px 16px",
                    minWidth: 160,
                    boxShadow:
                        "0 20px 40px -8px rgba(15,23,42,.18), 0 4px 10px -2px rgba(15,23,42,.08)",
                }}
            >
                <p
                    className="mb-2"
                    style={{
                        fontSize: 12.5,
                        fontWeight: 800,
                        color: "#0f172a",
                        letterSpacing: "-.2px",
                        display: "flex",
                        alignItems: "center",
                        gap: 6,
                    }}
                >
                    <span
                        style={{
                            width: 6,
                            height: 6,
                            borderRadius: "50%",
                            background: "#4d83ee",
                            flexShrink: 0,
                        }}
                    />
                    {payload[0]?.payload?.fullName}
                </p>

                <div
                    className="d-flex align-items-baseline justify-content-between"
                    style={{ gap: 14 }}
                >
                    <span
                        style={{
                            fontSize: 11,
                            fontWeight: 700,
                            color: "#94a3b8",
                            textTransform: "uppercase",
                            letterSpacing: ".4px",
                        }}
                    >
                        {selectedFilterLabel}
                    </span>
                    <span
                        style={{
                            fontSize: 15,
                            fontWeight: 900,
                            color: "#101820",
                            letterSpacing: "-.3px",
                        }}
                    >
                        {isCount
                            ? Number(val).toLocaleString("en-IN")
                            : `₹${Number(val).toLocaleString("en-IN", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                              })}`}
                    </span>
                </div>
            </div>
        );
    };

    return (
        <Container fluid className="py-3" style={{ background: "#fff" }}>
            <style>{`
        .reelo-select {
          border: 1px solid #d7e2e5 !important;
          border-radius: 12px !important;
          font-size: 13px !important;
          font-weight: 700 !important;
          color: #334155 !important;
          box-shadow: none !important;
          min-height: 42px;
        }

        .reelo-date-input,
        .date-picker-wrapper input {
          border: 1px solid #d7e2e5 !important;
          border-radius: 10px !important;
          height: 36px !important;
          font-size: 12px !important;
          font-weight: 600 !important;
          color: #334155 !important;
          box-shadow: none !important;
        }

        .reelo-table-wrap {
          scrollbar-width: thin;
          scrollbar-color: #a8dedb transparent;
        }

        .reelo-table-wrap::-webkit-scrollbar {
          height: 8px;
          width: 8px;
        }

        .reelo-table-wrap::-webkit-scrollbar-track {
          background: transparent;
        }

        .reelo-table-wrap::-webkit-scrollbar-thumb {
          background: #cfe4e2;
          border-radius: 999px;
        }

        .reelo-table-wrap::-webkit-scrollbar-thumb:hover {
          background: #0ea5a4;
        }

        .reelo-row:hover {
          background: #f7fbfc !important;
        }

        .reelo-tab-btn {
          border: 1px solid #d7e2e5 !important;
          background: #fff !important;
          color: #475569 !important;
          font-weight: 800 !important;
          font-size: 13px !important;
          padding: 10px 18px !important;
        }

        .reelo-tab-btn.active {
          background: #101820 !important;
          color: #fff !important;
          border-color: #101820 !important;
        }

        .reelo-thead-cell {
          position: sticky;
          top: 0;
          z-index: 3;
          background: #fbfcfd;
          overflow: visible;
        }

        .reelo-sticky-col {
          position: sticky;
          left: 0;
          z-index: 2;
          background: inherit;
          box-shadow: none;
          transition: box-shadow .15s ease;
        }

        .is-scrolled-left .reelo-sticky-col {
          box-shadow: 6px 0 12px -8px rgba(15,23,42,.30);
        }

        thead .reelo-sticky-col {
          z-index: 4;
          background: #fbfcfd;
        }

        .reelo-table-outer {
          position: relative;
        }

        .reelo-scroll-edge {
          position: absolute;
          top: 0;
          bottom: 0;
          width: 64px;
          pointer-events: none;
          z-index: 5;
          opacity: 0;
          transition: opacity .18s ease;
        }

        .reelo-scroll-edge.visible {
          opacity: 1;
        }

        .reelo-scroll-edge.edge-left {
          left: 0;
          background: linear-gradient(to right, rgba(255,255,255,.98), rgba(255,255,255,0));
        }

        .reelo-scroll-edge.edge-right {
          right: 0;
          background: linear-gradient(to left, rgba(255,255,255,.98), rgba(255,255,255,0));
        }

        .reelo-scroll-btn {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          width: 32px;
          height: 32px;
          border-radius: 999px;
          border: 1px solid #d7e2e5;
          background: #fff;
          color: #475569;
          display: grid;
          place-items: center;
          font-size: 14px;
          z-index: 6;
          box-shadow: 0 6px 16px rgba(15,23,42,.12);
          cursor: pointer;
          opacity: 0;
          pointer-events: none;
          transition: opacity .18s ease, background .15s ease, color .15s ease, box-shadow .15s ease;
        }

        .reelo-scroll-btn.visible {
          opacity: 1;
          pointer-events: auto;
        }

        .reelo-scroll-btn.btn-left { left: 10px; }
        .reelo-scroll-btn.btn-right { right: 10px; }

        .reelo-scroll-btn:hover {
          background: #101820;
          color: #fff;
          box-shadow: 0 10px 22px rgba(15,23,42,.22);
        }

        .reelo-col-menu-wrap {
          position: relative;
        }

        .reelo-col-menu {
          position: absolute;
          top: calc(100% + 8px);
          right: 0;
          width: 272px;
          max-height: 360px;
          overflow-y: auto;
          background: #fff;
          border: 1px solid #dbe5e8;
          border-radius: 14px;
          box-shadow: 0 20px 44px rgba(15,23,42,.16);
          padding: 8px;
          z-index: 30;
        }

        .reelo-col-menu-title {
          font-size: 11px;
          font-weight: 900;
          text-transform: uppercase;
          letter-spacing: .5px;
          color: #94a3b8;
          padding: 8px 10px 4px;
        }

        .reelo-col-menu-item {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 8px 10px;
          border-radius: 8px;
          font-size: 13px;
          font-weight: 600;
          color: #334155;
          cursor: pointer;
        }

        .reelo-col-menu-item:hover {
          background: #f4fbff;
        }

        .reelo-col-menu-item.disabled {
          opacity: .55;
          cursor: not-allowed;
        }

        .reelo-col-menu-item input {
          accent-color: #0ea5a4;
          width: 15px;
          height: 15px;
        }

        .outlet-sales-row {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 10px;
          padding: 7px 0;
          border-bottom: 1px dashed rgba(15,23,42,.07);
        }

        .outlet-sales-row:last-child {
          border-bottom: none;
        }

        .net-sales-flip-outer {
          perspective: 1200px;
          cursor: pointer;
          height: 100%;
        }

        .net-sales-flip-inner {
          position: relative;
          width: 100%;
          height: 100%;
          min-height: 118px;
          transform-style: preserve-3d;
          transition: transform .6s cubic-bezier(.4, .2, .2, 1);
        }

        .net-sales-flip-inner.is-flipped {
          transform: rotateY(180deg);
        }

        .net-sales-flip-face {
          position: absolute;
          inset: 0;
          backface-visibility: hidden;
          -webkit-backface-visibility: hidden;
          border-radius: 18px;
          padding: 20px 22px;
          border: 1px solid rgba(15,23,42,.04);
          box-shadow: 0 8px 22px rgba(15,23,42,.05);
          overflow: hidden;
        }

        .net-sales-flip-face.face-back {
          transform: rotateY(180deg);
        }

        .net-sales-flip-hint {
          font-size: 10px;
          opacity: .55;
        }
      `}</style>

            <div className="d-flex flex-wrap justify-content-between align-items-start gap-3 mb-4">
                <div>
                    <div className="d-flex align-items-center gap-2 mb-1">
                        <span
                            style={{
                                width: 34,
                                height: 34,
                                borderRadius: 12,
                                background: "#EAF7F8",
                                color: "#0ea5a4",
                                display: "grid",
                                placeItems: "center",
                                fontSize: 18,
                            }}
                        >
                            <i className="bi bi-bar-chart-line-fill" />
                        </span>
                        <h4 className="fw-bold mb-0" style={{ color: "#172126", letterSpacing: "-.4px" }}>
                            Outlet Statistics
                        </h4>
                    </div>
                    <p className="mb-0" style={{ color: "#708184", fontSize: 13, fontWeight: 500 }}>
                        Sales, orders and outlet-wise performance summary
                    </p>
                </div>

                <div
                    className="d-flex align-items-center flex-wrap gap-2"
                    style={{
                        background: "#fff",
                        border: "1px solid #dbe5e8",
                        borderRadius: 18,
                        padding: 8,
                        boxShadow: "0 8px 22px rgba(15,23,42,.04)",
                    }}
                >
                    <div
                        style={{
                            width: 36,
                            height: 36,
                            borderRadius: 12,
                            background: "#EAF7F8",
                            color: "#0ea5a4",
                            display: "grid",
                            placeItems: "center",
                        }}
                    >
                        <i className="bi bi-calendar-event" />
                    </div>

                    <div>
                        <Form.Select
                            value={dateFilter}
                            onChange={(e) => {
                                const val = e.target.value;
                                setDateFilter(val);
                                setCustomDateError("");

                                if (val === "custom") {
                                    const start = getDefaultStartDate();
                                    const end = new Date();

                                    setCustomStartDate(start);
                                    setCustomEndDate(end);
                                    setAppliedCustomRange({
                                        start: toLocalDateStr(start),
                                        end: toLocalDateStr(end),
                                    });
                                } else {
                                    setAppliedCustomRange(null);
                                    setCustomStartDate(null);
                                    setCustomEndDate(null);
                                }
                            }}
                            style={{ width: 155 }}
                            className="reelo-select"
                        >
                            {DATE_FILTER_OPTIONS.map((opt) => (
                                <option key={opt.value} value={opt.value}>
                                    {opt.label}
                                </option>
                            ))}
                        </Form.Select>

                        {["last7days", "last30days", "thisMonth", "lastMonth"].includes(dateFilter) && (
                            <span style={{ fontSize: 11, color: "#94a3b8", width: "100%", paddingLeft: 10 }}>
                                * Today's data not included
                            </span>
                        )}
                    </div>

                    {dateFilter === "custom" && (
                        <div className="d-flex align-items-end gap-2 flex-wrap">
                            <div>
                                <span className="me-1" style={{ fontSize: 10, color: "#64748b", fontWeight: 700 }}>Start</span>
                                <DatePicker
                                    selected={customStartDate}
                                    onChange={(date) => {
                                        setCustomStartDate(date);

                                        if (date) {
                                            const today = new Date();
                                            const maxAllowedEnd = new Date(date);
                                            maxAllowedEnd.setDate(maxAllowedEnd.getDate() + 89);
                                            const suggestedEnd = maxAllowedEnd > today ? today : maxAllowedEnd;

                                            if (!customEndDate) {
                                                setCustomEndDate(suggestedEnd);
                                            } else {
                                                const diff = inclusiveDayCount(date, customEndDate);
                                                if (diff > 90 || diff < 1) {
                                                    setCustomEndDate(suggestedEnd);
                                                }
                                            }
                                        }
                                        setCustomDateError("");
                                    }}
                                    selectsStart
                                    startDate={customStartDate}
                                    endDate={customEndDate}
                                    maxDate={new Date()}
                                    dateFormat="dd-MM-yyyy"
                                    placeholderText="Start date"
                                    className="form-control form-control-sm reelo-date-input"
                                    wrapperClassName="date-picker-wrapper"
                                    withPortal
                                />
                            </div>

                            <div>
                                <span className="me-1" style={{ fontSize: 10, color: "#64748b", fontWeight: 700 }}>End</span>
                                <DatePicker
                                    selected={customEndDate}
                                    onChange={(date) => {
                                        setCustomEndDate(date);
                                        setCustomDateError("");
                                    }}
                                    selectsEnd
                                    startDate={customStartDate}
                                    endDate={customEndDate}
                                    minDate={customStartDate}
                                    maxDate={
                                        customStartDate
                                            ? new Date(
                                                Math.min(
                                                    new Date(customStartDate).setDate(customStartDate.getDate() + 89),
                                                    new Date()
                                                )
                                            )
                                            : new Date()
                                    }
                                    disabled={!customStartDate}
                                    dateFormat="dd-MM-yyyy"
                                    placeholderText="End date"
                                    className="form-control form-control-sm reelo-date-input"
                                    wrapperClassName="date-picker-wrapper"
                                    withPortal
                                />
                            </div>

                            <Button
                                size="sm"
                                onClick={handleApplyCustomRange}
                                disabled={!customStartDate || !customEndDate}
                                style={{
                                    height: 36,
                                    borderRadius: 10,
                                    background: "#101820",
                                    borderColor: "#101820",
                                    fontWeight: 800,
                                    paddingInline: 16,
                                }}
                            >
                                Apply
                            </Button>
                        </div>
                    )}

                    {dateFilter === "custom" && customDateError && (
                        <span style={{ fontSize: 11, color: "#dc2626", width: "100%", paddingLeft: 48 }}>
                            ⚠ {customDateError}
                        </span>
                    )}
                </div>
            </div>

            <div className="row g-3 mb-4">
                {SUMMARY_CARDS.map((card) => {
                    const displayValue = totalsData?.[card.key] ?? calculatedTotals?.[card.key];

                    if (card.key === "totalRevenue") {
                        return (
                            <div key={card.key} className="col-12 col-sm-6 col-xl-3">
                                <div
                                    className="net-sales-flip-outer"
                                    onClick={() => setShowTotalSalesIncl((prev) => !prev)}
                                    role="button"
                                    tabIndex={0}
                                    aria-label="Toggle Total Sales figure to include Zomato/Swiggy"
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter" || e.key === " ") {
                                            e.preventDefault();
                                            setShowTotalSalesIncl((prev) => !prev);
                                        }
                                    }}
                                >
                                    <div className={`net-sales-flip-inner${showTotalSalesIncl ? " is-flipped" : ""}`}>
                                        <div className="net-sales-flip-face face-back" style={{ background: card.bg }}>
                                            <ReeloShape type={card.shape} accent={card.accent} />
                                            <div style={{ position: "relative", zIndex: 2 }}>
                                                <div
                                                    className="d-flex align-items-center gap-2 mb-2"
                                                    style={{ color: card.accent, fontSize: 15, fontWeight: 900 }}
                                                >
                                                    <span>{card.label}</span>
                                                    <i className="bi bi-arrow-repeat net-sales-flip-hint" />
                                                </div>

                                                {loading || loadingOutlets ? (
                                                    <Spinner animation="border" size="sm" style={{ color: card.accent }} />
                                                ) : (
                                                    <>
                                                        {Number(
                                                            totalsData?.totalCancelledOrderAmount ??
                                                            calculatedTotals?.totalCancelledOrderAmount ??
                                                            0
                                                        ) > 0 && (
                                                            <div style={{ fontSize: 12, fontWeight: 700, color: "#ef4444", marginBottom: 2 }}>
                                                                ₹
                                                                {Number(
                                                                    totalsData?.totalCancelledOrderAmount ??
                                                                    calculatedTotals?.totalCancelledOrderAmount ??
                                                                    0
                                                                ).toLocaleString("en-IN", {
                                                                    minimumFractionDigits: 2,
                                                                    maximumFractionDigits: 2,
                                                                })}{" "}
                                                                / {Number(totalsData?.cancelledOrders ?? calculatedTotals?.cancelledOrders ?? 0)} Cancelled
                                                            </div>
                                                        )}

                                                        <div
                                                            style={{
                                                                fontSize: 26,
                                                                lineHeight: 1.1,
                                                                fontWeight: 900,
                                                                color: "#142124",
                                                                letterSpacing: "-.9px",
                                                            }}
                                                        >
                                                            {formatCardValue(displayValue)}
                                                        </div>

                                                        <div style={{ fontSize: 12, fontWeight: 700, color: "#64748b", marginTop: 4 }}>
                                                            {getNetOrdersTotal().toLocaleString("en-IN")} Orders
                                                        </div>

                                                        {Number(
                                                            totalsData?.complimentaryOrders ??
                                                            calculatedTotals?.complimentaryOrders ??
                                                            0
                                                        ) > 0 && (
                                                            <div
                                                                style={{
                                                                    fontSize: 11,
                                                                    fontWeight: 700,
                                                                    color: "#7c3aed",
                                                                    marginTop: 3,
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    gap: 4,
                                                                }}
                                                                title="Complimentary orders are not counted in Total Orders"
                                                            >
                                                                +
                                                                {Number(
                                                                    totalsData?.complimentaryOrders ??
                                                                    calculatedTotals?.complimentaryOrders ??
                                                                    0
                                                                ).toLocaleString("en-IN")}{" "}
                                                                Complimentary
                                                            </div>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        </div>

                                        <div className="net-sales-flip-face face-front" style={{ background: card.bg }}>
                                            <ReeloShape type={card.shape} accent={card.accent} />
                                            <div style={{ position: "relative", zIndex: 2 }}>
                                                <div
                                                    className="d-flex align-items-center gap-2 mb-2"
                                                    style={{ color: card.accent, fontSize: 13, fontWeight: 900 }}
                                                >
                                                    <span>Gross Sales</span>
                                                    <i className="bi bi-arrow-repeat net-sales-flip-hint" />
                                                </div>

                                                {loading || loadingOutlets ? (
                                                    <Spinner animation="border" size="sm" style={{ color: card.accent }} />
                                                ) : (
                                                    <div
                                                        style={{
                                                            fontSize: 24,
                                                            lineHeight: 1.1,
                                                            fontWeight: 900,
                                                            color: "#142124",
                                                            letterSpacing: "-.9px",
                                                        }}
                                                    >
                                                        {formatCardValue(totalSalesInclThirdPartyTotal)}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    }

                    if (card.key === "netSaleRevenue") {
                        return (
                            <div key={card.key} className="col-12 col-sm-6 col-xl-3">
                                <div
                                    className="net-sales-flip-outer"
                                    onClick={() => setShowNetSalesIncl((prev) => !prev)}
                                    role="button"
                                    tabIndex={0}
                                    aria-label="Toggle Net Sales figure to include Zomato/Swiggy"
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter" || e.key === " ") {
                                            e.preventDefault();
                                            setShowNetSalesIncl((prev) => !prev);
                                        }
                                    }}
                                >
                                    <div className={`net-sales-flip-inner${showNetSalesIncl ? " is-flipped" : ""}`}>
                                        <div className="net-sales-flip-face face-back" style={{ background: card.bg }}>
                                            <ReeloShape type={card.shape} accent={card.accent} />
                                            <div style={{ position: "relative", zIndex: 2 }}>
                                                <div
                                                    className="d-flex align-items-center gap-2 mb-2"
                                                    style={{ color: card.accent, fontSize: 15, fontWeight: 900 }}
                                                >
                                                    <span>{card.label}</span>
                                                    <i className="bi bi-arrow-repeat net-sales-flip-hint" />
                                                </div>

                                                {loading || loadingOutlets ? (
                                                    <Spinner animation="border" size="sm" style={{ color: card.accent }} />
                                                ) : (
                                                    <div
                                                        style={{
                                                            fontSize: 26,
                                                            lineHeight: 1.1,
                                                            fontWeight: 900,
                                                            color: "#142124",
                                                            letterSpacing: "-.9px",
                                                        }}
                                                    >
                                                        {formatCardValue(displayValue)}
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        <div className="net-sales-flip-face face-front" style={{ background: card.bg }}>
                                            <ReeloShape type={card.shape} accent={card.accent} />
                                            <div style={{ position: "relative", zIndex: 2 }}>
                                                <div
                                                    className="d-flex align-items-center gap-2 mb-2"
                                                    style={{ color: card.accent, fontSize: 13, fontWeight: 900 }}
                                                >
                                                    <span>Net Sales</span>
                                                    <i className="bi bi-arrow-repeat net-sales-flip-hint" />
                                                </div>

                                                {loading || loadingOutlets ? (
                                                    <Spinner animation="border" size="sm" style={{ color: card.accent }} />
                                                ) : (
                                                    <div
                                                        style={{
                                                            fontSize: 24,
                                                            lineHeight: 1.1,
                                                            fontWeight: 900,
                                                            color: "#142124",
                                                            letterSpacing: "-.9px",
                                                        }}
                                                    >
                                                        {formatCardValue(netSalesInclThirdPartyTotal)}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    }

                    return (
                        <div key={card.key} className="col-12 col-sm-6 col-xl-3">
                            <div
                                className="position-relative overflow-hidden h-100"
                                style={{
                                    borderRadius: 18,
                                    background: card.bg,
                                    minHeight: 118,
                                    padding: "20px 22px",
                                    border: "1px solid rgba(15,23,42,.04)",
                                    boxShadow: "0 8px 22px rgba(15,23,42,.05)",
                                }}
                            >
                                <ReeloShape type={card.shape} accent={card.accent} />

                                <div style={{ position: "relative", zIndex: 2 }}>
                                    <div
                                        className="d-flex align-items-center gap-2 mb-2"
                                        style={{ color: card.accent, fontSize: 15, fontWeight: 900 }}
                                    >
                                        <span>{card.label}</span>
                                    </div>

                                    {loading || loadingOutlets ? (
                                        <Spinner animation="border" size="sm" style={{ color: card.accent }} />
                                    ) : (
                                        <div
                                            style={{
                                                fontSize: 26,
                                                lineHeight: 1.1,
                                                fontWeight: 900,
                                                color: "#142124",
                                                letterSpacing: "-.9px",
                                            }}
                                        >
                                            {formatCardValue(displayValue)}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    );
                })}

                <div className="col-12 col-sm-6 col-xl-3">
                    <div
                        className="position-relative overflow-hidden h-100"
                        style={{
                            borderRadius: 18,
                            background: OUTLET_SALES_CARD.bg,
                            minHeight: 118,
                            padding: "18px 20px",
                            border: "1px solid rgba(15,23,42,.05)",
                            boxShadow: "0 8px 22px rgba(15,23,42,.06)",
                        }}
                    >
                        <div
                            className="d-flex align-items-center gap-2 mb-3"
                            style={{ color: OUTLET_SALES_CARD?.accent, fontSize: 15, fontWeight: 900 }}
                        >
                            <span style={{ color: "#2563EB" }}>{OUTLET_SALES_CARD.label}</span>
                        </div>

                        {loading || loadingOutlets ? (
                            <Spinner animation="border" size="sm" style={{ color: OUTLET_SALES_CARD.accent }} />
                        ) : (
                            <div>
                                {OUTLET_SALES_ITEMS.map((item) => {
                                    const displayValue = totalsData?.[item.key] ?? calculatedTotals?.[item.key];
                                    const orderCount = totalsData?.[item.countKey] ?? calculatedTotals?.[item.countKey] ?? 0;

                                    return (
                                        <div key={item.key} className="outlet-sales-row p-1">
                                            <div className="d-flex align-items-center gap-2">
                                                <div>
                                                    <div style={{ fontSize: 10.5, fontWeight: 800, color: "#334155" }}>
                                                        {item.label} <span style={{ fontSize: 9.5, fontWeight: 700, color: "#94a3b8" }}>{Number(orderCount).toLocaleString("en-IN")} Orders</span>
                                                    </div>
                                                </div>
                                            </div>

                                            <span style={{ fontSize: 11.5, fontWeight: 900, color: "#142124" }}>
                                                {formatCardValue(displayValue)}
                                            </span>
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <div
                style={{
                    border: "1px solid #cfdcdf",
                    borderRadius: 18,
                    background: "#fff",
                    boxShadow: "0 10px 26px rgba(15,23,42,.04)",
                    overflow: "hidden",
                }}
            >
                <div
                    className="d-flex justify-content-between align-items-center flex-wrap gap-3"
                    style={{ padding: "20px 24px 12px" }}
                >
                    <div>
                        <div className="d-flex align-items-center gap-2">
                            <i className="bi bi-rupee" style={{ color: "#64748b", fontSize: 22 }} />
                            <h5 className="mb-0 fw-bold" style={{ color: "#172126" }}>
                                Revenue
                            </h5>
                        </div>
                        {viewMode === "list" && !loading && !loadingOutlets && (
                            <p className="mb-0" style={{ fontSize: 11.5, color: "#94a3b8", fontWeight: 700, marginTop: 3 }}>
                                {visibleTableColumns.length} of {displayColumns.length} columns shown
                                {displayColumns.length > 5 ? " · scroll horizontally for more" : ""}
                            </p>
                        )}
                    </div>

                    <div className="d-flex align-items-center gap-2">
                        <Button
                            className={`reelo-tab-btn ${viewMode === "list" ? "active" : ""}`}
                            onClick={() => setViewMode("list")}
                            style={{ borderRadius: "12px 0 0 12px" }}
                        >
                            <i className="bi bi-list-ul me-2" />
                            List
                        </Button>
                        <Button
                            className={`reelo-tab-btn ${viewMode === "graph" ? "active" : ""}`}
                            onClick={() => setViewMode("graph")}
                            style={{ borderRadius: viewMode === "list" ? 0 : "0 12px 12px 0" }}
                        >
                            <i className="bi bi-bar-chart-fill me-2" />
                            Graph
                        </Button>

                        {viewMode === "list" && (
                            <div className="reelo-col-menu-wrap" ref={columnMenuRef}>
                                <Button
                                    className="reelo-tab-btn"
                                    onClick={() => setShowColumnMenu((prev) => !prev)}
                                    style={{ borderRadius: "0 12px 12px 0" }}
                                    aria-label="Customize columns"
                                    aria-expanded={showColumnMenu}
                                >
                                    <i className="bi bi-sliders me-2" />
                                    Columns
                                    {hiddenColumnCount > 0 && (
                                        <span
                                            style={{
                                                marginLeft: 6,
                                                background: "#0ea5a4",
                                                color: "#fff",
                                                borderRadius: 999,
                                                fontSize: 10,
                                                fontWeight: 900,
                                                padding: "1px 6px",
                                            }}
                                        >
                                            -{hiddenColumnCount}
                                        </span>
                                    )}
                                </Button>

                                {showColumnMenu && (
                                    <div className="reelo-col-menu">
                                        <div className="reelo-col-menu-title">Visible Columns</div>
                                        {displayColumns.map((col) => {
                                            const isOutlet = col.key === "outletName";
                                            const isChecked = isOutlet || columnVisibility[col.key] !== false;

                                            return (
                                                <label
                                                    key={col.key}
                                                    className={`reelo-col-menu-item${isOutlet ? " disabled" : ""}`}
                                                >
                                                    <input
                                                        type="checkbox"
                                                        checked={isChecked}
                                                        disabled={isOutlet}
                                                        onChange={() => !isOutlet && toggleColumnVisibility(col.key)}
                                                    />
                                                    {col.label}
                                                </label>
                                            );
                                        })}
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>

                {viewMode === "graph" && (
                    <>
                        <div className="d-flex gap-2 flex-wrap px-4 pb-3">
                            <Form.Select
                                value={filterType}
                                onChange={(e) => setFilterType(e.target.value)}
                                style={{ width: 170 }}
                                className="reelo-select"
                            >
                                {FILTER_OPTIONS.map((opt) => (
                                    <option key={opt.value} value={opt.value}>
                                        {opt.label}
                                    </option>
                                ))}
                            </Form.Select>

                            <Form.Select
                                value={sortType}
                                onChange={(e) => setSortType(e.target.value)}
                                style={{ width: 185 }}
                                className="reelo-select"
                            >
                                {SORT_OPTIONS.map((opt) => (
                                    <option key={opt.value} value={opt.value}>
                                        {opt.label}
                                    </option>
                                ))}
                            </Form.Select>
                        </div>

                        <div style={{ padding: "0 18px 24px" }}>
                            {loading || loadingOutlets ? (
                                <div className="d-flex justify-content-center align-items-center" style={{ height: 420 }}>
                                    <Spinner animation="border" style={{ color: "#0ea5a4" }} />
                                </div>
                            ) : chartData.length === 0 ? (
                                <div className="d-flex justify-content-center align-items-center text-muted" style={{ height: 360 }}>
                                    No data available
                                </div>
                            ) : (
                                <ResponsiveContainer width="100%" height={460}>
                                    <BarChart data={chartData} barSize={54} margin={{ top: 30, right: 28, left: 4, bottom: 20 }}>
                                        <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#eef2f7" />
                                        <XAxis
                                            dataKey="name"
                                            tick={{ fontSize: 11, fill: "#6b7280", fontWeight: 700 }}
                                            axisLine={false}
                                            tickLine={false}
                                            angle={-16}
                                            textAnchor="end"
                                            interval={0}
                                        />
                                        <YAxis
                                            tick={{ fontSize: 11, fill: "#6b7280", fontWeight: 700 }}
                                            axisLine={false}
                                            tickLine={false}
                                            tickFormatter={(v) =>
                                                isAmount
                                                    ? v >= 1000
                                                        ? `₹${(v / 1000).toFixed(1)}K`
                                                        : `₹${v}`
                                                    : v.toLocaleString("en-IN")
                                            }
                                        />
                                        <Tooltip
                                            content={<CustomTooltip />}
                                            cursor={{ fill: "rgba(77, 131, 238, 0.06)", radius: 6 }}
                                        />
                                        <Legend
                                            verticalAlign="bottom"
                                            wrapperStyle={{ paddingTop: 28, fontWeight: 700 }}
                                            formatter={() => selectedFilterLabel}
                                        />
                                        <Bar dataKey="value" fill="#4d83ee" radius={[7, 7, 0, 0]} animationDuration={800} />
                                    </BarChart>
                                </ResponsiveContainer>
                            )}
                        </div>
                    </>
                )}

                {viewMode === "list" && (
                    <div className="reelo-table-outer" style={{ padding: "0 18px 18px" }}>
                        {loading || loadingOutlets ? (
                            <div className="d-flex justify-content-center align-items-center" style={{ height: 360 }}>
                                <Spinner animation="border" style={{ color: "#0ea5a4" }} />
                            </div>
                        ) : (
                            <>
                                <div
                                    ref={tableWrapRef}
                                    className={`reelo-table-wrap${tableScrolledLeft ? " is-scrolled-left" : ""}`}
                                    onScroll={handleTableScroll}
                                    style={{
                                        overflowX: "auto",
                                        overflowY: "auto",
                                        maxHeight: TABLE_BODY_MAX_HEIGHT,
                                        borderRadius: 12,
                                    }}
                                >
                                    <table
                                        className="w-100"
                                        style={{
                                            borderCollapse: "separate",
                                            borderSpacing: "0 8px",
                                            fontSize: 13,
                                            minWidth: tableMinWidth,
                                        }}
                                    >
                                        <colgroup>
                                            {visibleTableColumns.map((col) => (
                                                <col key={col.key} style={{ width: getColumnWidth(col) }} />
                                            ))}
                                        </colgroup>

                                        <thead>
                                            <tr>
                                                {visibleTableColumns.map((col, colIndex) => (
                                                    <th
                                                        key={col.key}
                                                        onClick={() => col.sortable && handleTableSort(col.key)}
                                                        className={`reelo-thead-cell${colIndex === 0 ? " reelo-sticky-col" : ""}`}
                                                        style={{
                                                            padding: "12px 16px",
                                                            fontSize: 11,
                                                            fontWeight: 900,
                                                            textTransform: "uppercase",
                                                            letterSpacing: ".5px",
                                                            color: "#748588",
                                                            textAlign:
                                                                col.type === "amount" || col.type === "combo"
                                                                    ? "right"
                                                                    : col.type === "count"
                                                                        ? "center"
                                                                        : "left",
                                                            whiteSpace: "nowrap",
                                                            cursor: col.sortable ? "pointer" : "default",
                                                            borderBottom: "1px solid #edf3f5",
                                                        }}
                                                    >
                                                        <span
                                                            style={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                gap: 6,
                                                                justifyContent:
                                                                    col.type === "amount" || col.type === "combo"
                                                                        ? "flex-end"
                                                                        : col.type === "count"
                                                                            ? "center"
                                                                            : "flex-start",
                                                            }}
                                                        >
                                                            {col.label}
                                                            {col.helperText && <InfoTooltip text={col.helperText} />}
                                                            {col.sortable && (
                                                                <span style={{ color: sortConfig.key === col.key ? "#0ea5a4" : "#cbd5e1", fontSize: 12 }}>
                                                                    {sortConfig.key === col.key
                                                                        ? sortConfig.direction === "asc"
                                                                            ? "↑"
                                                                            : "↓"
                                                                        : "↕"}
                                                                </span>
                                                            )}
                                                        </span>
                                                    </th>
                                                ))}
                                            </tr>
                                        </thead>

                                        <tbody>
                                            <tr
                                                style={{
                                                    background: "#f0f9f9",
                                                    boxShadow: "inset 0 0 0 1px #d7ecec",
                                                }}
                                            >
                                                <td
                                                    className="reelo-sticky-col"
                                                    style={{
                                                        padding: "16px",
                                                        fontWeight: 900,
                                                        color: "#0f172a",
                                                        fontSize: 12,
                                                        textTransform: "uppercase",
                                                        letterSpacing: ".4px",
                                                        whiteSpace: "nowrap",
                                                    }}
                                                >
                                                    Total (All Outlets)
                                                </td>

                                                {visibleTableColumns.slice(1).map((col) => (
                                                    <td
                                                        key={col.key}
                                                        style={{
                                                            padding: "16px",
                                                            textAlign:
                                                                col.type === "amount" || col.type === "combo"
                                                                    ? "right"
                                                                    : col.type === "count"
                                                                        ? "center"
                                                                        : "left",
                                                            color:
                                                                col.key === "cancelledOrders" ||
                                                                col.key === "totalCancelledOrderAmount" ||
                                                                col.key === "cancelledCombo"
                                                                    ? "#dc2626"
                                                                    : col.key === "complimentaryOrders"
                                                                        ? "#7c3aed"
                                                                        : "#0f172a",
                                                            fontWeight: 900,
                                                            whiteSpace: "nowrap",
                                                        }}
                                                    >
                                                        {col.type === "combo" ? renderComboCell(col, null) : formatTotalCell(col)}
                                                    </td>
                                                ))}
                                            </tr>

                                            {sortedData?.length === 0 ? (
                                                <tr>
                                                    <td
                                                        colSpan={visibleTableColumns?.length}
                                                        style={{
                                                            padding: "44px 16px",
                                                            textAlign: "center",
                                                            color: "#94a3b8",
                                                            fontWeight: 700,
                                                        }}
                                                    >
                                                        No outlet data available
                                                    </td>
                                                </tr>
                                            ) : (
                                                sortedData.map((outlet, idx) => (
                                                    <tr
                                                        key={outlet?._id || idx}
                                                        className="reelo-row"
                                                        style={{
                                                            background: "#fff",
                                                            boxShadow: "inset 0 0 0 1px #edf3f5",
                                                            cursor: "pointer",
                                                            transition: "background .15s ease",
                                                        }}
                                                    >
                                                        <td
                                                            className="reelo-sticky-col"
                                                            onClick={() =>
                                                                handleViewModal(
                                                                    {
                                                                        isNumeric: false,
                                                                        key: "outletName",
                                                                        label: "Outlet Name",
                                                                        sortable: true,
                                                                        type: "text",
                                                                    },
                                                                    outlet
                                                                )
                                                            }
                                                            style={{
                                                                padding: "15px 16px",
                                                                color: "#0f766e",
                                                                fontWeight: 800,
                                                                whiteSpace: "nowrap",
                                                                cursor: "pointer",
                                                            }}
                                                        >
                                                            <span
                                                                style={{
                                                                    width: 28,
                                                                    height: 28,
                                                                    borderRadius: 10,
                                                                    background: "#EAF7F8",
                                                                    color: "#0ea5a4",
                                                                    display: "inline-grid",
                                                                    placeItems: "center",
                                                                    marginRight: 10,
                                                                }}
                                                            >
                                                                <i className="bi bi-shop" />
                                                            </span>
                                                            {outlet?.outletName || "—"}
                                                            <span style={{ color: "#94a3b8", marginLeft: 8 }}>›</span>
                                                        </td>

                                                        {visibleTableColumns.slice(1).map((col) => (
                                                            <td
                                                                key={col.key}
                                                                onClick={() => handleViewModal(col, outlet)}
                                                                style={{
                                                                    padding: "15px 16px",
                                                                    textAlign:
                                                                        col.type === "amount" || col.type === "combo"
                                                                            ? "right"
                                                                            : col.type === "count"
                                                                                ? "center"
                                                                                : "left",
                                                                    color:
                                                                        col.key === "cancelledOrders" ||
                                                                        col.key === "totalCancelledOrderAmount" ||
                                                                        col.key === "cancelledCombo"
                                                                            ? "#dc2626"
                                                                            : col.key === "complimentaryOrders"
                                                                                ? "#7c3aed"
                                                                                : "#334155",
                                                                    fontWeight: col.type === "amount" ? 800 : 700,
                                                                    whiteSpace: "nowrap",
                                                                }}
                                                            >
                                                                {col.type === "combo" ? renderComboCell(col, outlet) : formatCell(col, outlet)}
                                                            </td>
                                                        ))}
                                                    </tr>
                                                ))
                                            )}
                                        </tbody>
                                    </table>
                                </div>

                                <div className={`reelo-scroll-edge edge-left${tableScrolledLeft ? " visible" : ""}`} />
                                <div className={`reelo-scroll-edge edge-right${canScrollRight ? " visible" : ""}`} />

                                <button
                                    type="button"
                                    className={`reelo-scroll-btn btn-left${tableScrolledLeft ? " visible" : ""}`}
                                    onClick={() => scrollTableBy(-ARROW_SCROLL_DELTA)}
                                    aria-label="Scroll table left"
                                    title="Scroll left"
                                >
                                    <i className="bi bi-chevron-left" />
                                </button>
                                <button
                                    type="button"
                                    className={`reelo-scroll-btn btn-right${canScrollRight ? " visible" : ""}`}
                                    onClick={() => scrollTableBy(ARROW_SCROLL_DELTA)}
                                    aria-label="Scroll table right"
                                    title="Scroll right"
                                >
                                    <i className="bi bi-chevron-right" />
                                </button>

                                <p style={{ fontSize: 12, color: "#94a3b8", margin: "8px 0 0 4px", fontWeight: 600 }}>
                                    Click any row to view outlet details
                                </p>
                            </>
                        )}
                    </div>
                )}
            </div>

            {openViewModal && (
                <OutletDetailsModal
                    isOpen={openViewModal}
                    onClose={() => {
                        setOpenViewModal(false);
                        setViewModalData(null);
                    }}
                    outletName={selectedOutletName}
                    data={viewModalData}
                    loading={viewModalLoading}
                />
            )}
        </Container>
    );
};

OutletRevenueKpi.propTypes = {
    outletFilter: PropTypes.string.isRequired,
    loadingOutlets: PropTypes.bool.isRequired,
};

export default OutletRevenueKpi;